import React, { useContext } from "react";
import styled, { withTheme, ThemeContext } from "styled-components";

//refaktoriraj gi svi ostali ikone u nizu
//ubaci gi ikone od Static folder u nizu

// Styled components
const IconContainer = styled.svg`
  position: relative;
  @media (pointer: fine) {
    &:hover {
      path {
        fill: ${(props) => props.hoverFill};
      }
    }
  }
`;

const Path = styled.path`
  &.stroke-${({ stroking }) => stroking} {
    stroke: ${({ theme, stroking, stroke }) =>
    stroke ? stroke : theme[stroking]};
  }
  &.fill-${({ filling }) => filling} {
    fill: ${({ theme, filling, fill }) => (fill ? fill : theme[filling])};
  }
`;

const Circle = styled.circle`
  &.stroke-${({ stroking }) => stroking} {
    stroke: ${({ theme, stroking }) => theme[stroking]};
  }
  &.fill-${({ filling }) => filling} {
    fill: ${({ theme, filling }) => theme[filling]};
  }
`;

const Rect = styled.rect`
  &.stroke-${({ stroking }) => stroking} {
    stroke: ${({ theme, stroking }) => theme[stroking]};
  }
  &.fill-${({ filling }) => filling} {
    fill: ${({ theme, filling }) => theme[filling]};
  }
`;

const Polygon = styled.polygon`
  &.stroke-${({ stroking }) => stroking} {
    stroke: ${({ theme, stroking }) => theme[stroking]};
  }
  &.fill-${({ filling }) => filling} {
    fill: ${({ theme, filling }) => theme[filling]};
  }
`;



export const icons = {
  brainsterLogo: {
    paths: [
      {
        d: "M24.4,26.8h-0.2c-0.1,0-0.3,0-0.5,0.1l-4.6,2.7c-0.4,0.3-0.6,0.8-0.4,1.3c0.1,0.2,0.3,0.4,0.6,0.4 c0.2,0.1,0.5,0,0.7-0.1l4.1-2.4l4.1,2.4c0.1,0,0.2,0.1,0.2,0.1l0.2,0c0.3,0,0.6-0.2,0.8-0.5c0.1-0.2,0.1-0.5,0.1-0.7 c-0.1-0.2-0.2-0.4-0.5-0.5l-4.6-2.7L24.4,26.8z",
        fill: "black",
      },
      {
        d: "M39,14.3c0-0.3-0.2-0.6-0.5-0.8l-4.1-2.4V6.3c0-0.3-0.2-0.6-0.5-0.8L29.5,3c0,0-0.1-0.1-0.2-0.2l-4.6-2.7 c-0.3-0.2-0.6-0.2-1,0l-4.2,2.4l-4.2-2.4c-0.3-0.2-0.6-0.2-1,0L9.8,2.8C9.7,2.8,9.6,2.9,9.5,3L5.1,5.6C4.8,5.8,4.6,6.1,4.6,6.4v4.7 l-4.1,2.4C0.2,13.7,0,14,0,14.4l0,11.3c0,0.3,0.2,0.6,0.5,0.8l4.1,2.4v4.8c0,0.3,0.2,0.6,0.5,0.8L9.4,37c0,0,0.1,0.1,0.2,0.2 l4.6,2.7c0.1,0.1,0.3,0.1,0.5,0.1c0.2,0,0.3,0,0.5-0.1l4.2-2.4l4.2,2.4c0.1,0.1,0.3,0.1,0.5,0.1c0.2,0,0.3,0,0.5-0.1l4.6-2.7 c0.1,0,0.2-0.1,0.3-0.2l4.4-2.6c0.3-0.2,0.5-0.5,0.5-0.8v-4.8l4.1-2.4c0.4-0.1,0.6-0.5,0.6-0.8V14.3z M37.1,25.1l-3.6,2.1l-4.2-2.4 c-0.5-0.2-1.1-0.1-1.3,0.4c-0.1,0.2-0.1,0.5-0.1,0.7c0,0.2,0.2,0.5,0.5,0.6l4.1,2.4V33l-3.7,2.1l-4.1-2.4c-0.5-0.3-1.1-0.1-1.3,0.4 c-0.1,0.2-0.2,0.5-0.1,0.7c0,0.2,0.2,0.5,0.5,0.6l3.3,1.9L24.2,38L20,35.6c-0.2-0.1-0.4-0.1-0.6-0.1c-0.2,0-0.4,0-0.6,0.1L14.8,38 l-3.7-2.1V31c0-0.5-0.4-1-1-1c-0.5,0-1,0.4-1,1v3.6l-2.7-1.6v-4.2l3.7-2.1l3.7,2.1v4.8c0,0.5,0.4,1,1,1c0.5,0,1-0.4,1-1v-5.2 l3.3-1.9c0.2-0.1,0.4-0.3,0.5-0.6c0-0.2,0-0.5-0.1-0.7c-0.2-0.5-0.9-0.6-1.3-0.4l-3.7,2.1L11.2,25v-4.4l3.4-2 c0.2-0.1,0.4-0.3,0.5-0.6c0-0.2,0-0.5-0.1-0.7c-0.2-0.4-0.9-0.6-1.3-0.4l-3.5,2l-4-2.3C5.6,16.4,5,16.6,4.8,17 c-0.3,0.5-0.1,1.1,0.4,1.3l4.1,2.4V25l-3.6,2.1L2,25v-3.8l3.2,1.8c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.6-0.2,0.8-0.5 c0.3-0.5,0.1-1.1-0.4-1.3L2,19.1v-4.2l3.6-2.1l4.2,2.4c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.6-0.2,0.8-0.5c0.3-0.5,0.1-1.1-0.4-1.3 l-4.1-2.4V7l3.7-2.1l4.1,2.4c0.5,0.3,1.1,0.1,1.3-0.4c0.1-0.2,0.2-0.5,0.1-0.7c0-0.2-0.2-0.5-0.5-0.6L12,3.7L14.9,2L19,4.4 c0.1,0.1,0.3,0.1,0.5,0.1c0,0,0,0,0.1,0c0.2,0,0.4,0,0.6-0.1L24.3,2l3.7,2.1v4.8c0,0.5,0.4,1,1,1c0.5,0,1-0.4,1-1V5.3l2.7,1.6v4.2 l-3.7,2.1l-3.7-2.1V6.3c0-0.5-0.4-1-1-1c-0.5,0-1,0.4-1,1v5.2L20,13.4c-0.2,0.1-0.4,0.3-0.5,0.6c0,0.2,0,0.5,0.1,0.7 c0.2,0.3,0.5,0.5,0.8,0.5c0.2,0,0.3,0,0.5-0.1l3.7-2.1l3.3,1.9v4.5l-3.4,2c-0.5,0.3-0.6,0.8-0.4,1.3c0.2,0.3,0.5,0.5,0.8,0.5 c0.2,0,0.3,0,0.5-0.1l3.5-2l4,2.3c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.6-0.2,0.8-0.5c0.3-0.5,0.1-1.1-0.4-1.3l-4.1-2.4v-4.4l3.6-2.1 l3.7,2.1v3.8l-3.2-1.8c-0.5-0.3-1.1-0.1-1.3,0.4c-0.3,0.5-0.1,1.1,0.4,1.3l4.1,2.4V25.1z",
        fill: "black",
      },
      {
        d: "M22.1,19.2l0-0.1c0-0.3,0-0.5-0.1-0.7l0,0c-0.1-0.2-0.3-0.4-0.6-0.4c-0.2-0.1-0.5,0-0.7,0.1l-3.8,2.2 c-0.2,0.1-0.3,0.3-0.5,0.6c0,0.3,0,0.5,0.1,0.7c0.2,0.3,0.5,0.4,0.8,0.4c0.2,0,0.3,0,0.5-0.1l3.8-2.2C21.8,19.6,22,19.4,22.1,19.2z",
        fill: "black",
      },
      {
        d: "M20,10.3l0.1-0.1c0.1-0.1,0.1-0.2,0.1-0.3c0.1-0.3,0-0.5-0.1-0.7l0,0c-0.1-0.2-0.3-0.4-0.6-0.4 c-0.2-0.1-0.5-0.1-0.7,0.1l-4.1,2.4l-4.1-2.4c-0.2-0.1-0.5-0.2-0.7-0.1C9.7,8.7,9.5,8.9,9.4,9.1C9.2,9.3,9.2,9.6,9.3,9.8 c0.1,0.2,0.2,0.4,0.5,0.6l4.6,2.7c0.1,0,0.1,0.1,0.2,0.1l0.2,0c0.2,0,0.3,0,0.5-0.1l4.6-2.7L20,10.3z",
        fill: "black",
      },
    ],
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    style: "enable-background:new 0 0 39 40;",
  },
  brainsterNextLogo: {
    paths: [
      {
        d: "M7.68839 5.94678C7.58041 5.88221 7.58041 5.77457 7.66679 5.70999C8.31469 5.25794 8.72503 4.59062 8.72503 3.62193C8.72503 1.94287 7.55881 0.694336 5.26957 0.694336H0.323949C0.151176 0.694336 0 0.845021 0 1.01723V10.9624C0 11.1347 0.151176 11.2853 0.323949 11.2853H5.7447C7.90436 11.2853 9.20015 10.0583 9.20015 8.29316C9.20015 7.15226 8.61704 6.37731 7.68839 5.94678ZM2.72117 3.42819C2.72117 3.27751 2.85075 3.14835 3.00193 3.14835H5.11839C5.67991 3.14835 5.98226 3.49277 5.98226 3.98788C5.98226 4.48299 5.7015 4.82741 4.96722 4.82741H3.00193C2.85075 4.82741 2.72117 4.69825 2.72117 4.54757V3.42819ZM5.44234 8.83133H3.00193C2.85075 8.83133 2.72117 8.70217 2.72117 8.55148V7.23837C2.72117 7.08769 2.85075 6.95853 3.00193 6.95853H5.46394C6.19822 6.95853 6.47898 7.32448 6.47898 7.86264C6.45738 8.42232 6.17663 8.83133 5.44234 8.83133Z",
        fill: "#302F38",
      },
      {
        d: "M18.292 8.31469C18.2056 8.18553 18.2272 8.03485 18.3784 7.97027C19.6526 7.28142 20.2357 5.96831 20.2357 4.56909C20.2357 2.4595 18.9831 0.694336 16.2619 0.694336H11.3811C11.2083 0.694336 11.0571 0.845021 11.0571 1.01723V10.9624C11.0571 11.1347 11.2083 11.2853 11.3811 11.2853H13.4328C13.6055 11.2853 13.7567 11.1347 13.7567 10.9624V8.72369C13.7567 8.57301 13.8863 8.44385 14.0375 8.44385H14.8797C15.0525 8.44385 15.2253 8.52996 15.3117 8.65911L16.9746 11.0055C17.1042 11.1777 17.2985 11.2853 17.4929 11.2853H20.0845C20.2141 11.2853 20.3005 11.1347 20.2141 11.0055L18.292 8.31469ZM16.1107 5.98984H14.0591C13.9079 5.98984 13.7783 5.86068 13.7783 5.70999V3.42819C13.7783 3.27751 13.9079 3.14835 14.0591 3.14835H16.1107C17.1906 3.14835 17.6009 3.75109 17.6009 4.56909C17.6009 5.32252 17.1906 5.98984 16.1107 5.98984Z",
        fill: "#302F38",
      },
      {
        d: "M28.292 0.995706C28.2272 0.823495 28.0328 0.694336 27.8385 0.694336H25.7868C25.5924 0.694336 25.398 0.823495 25.3333 0.995706L21.2731 10.984C21.2083 11.1131 21.3163 11.2853 21.4675 11.2853H23.7783C23.9727 11.2853 24.1454 11.1562 24.2102 10.984L24.599 9.99375C24.6638 9.84307 24.7933 9.73544 24.9661 9.73544H28.6159C28.7887 9.73544 28.9399 9.84307 28.9831 9.99375L29.3718 10.984C29.4366 11.1562 29.6094 11.2853 29.8037 11.2853H32.1146C32.2874 11.2853 32.3737 11.1131 32.309 10.984L28.292 0.995706ZM27.6873 7.28142H25.8948C25.7652 7.28142 25.6788 7.15227 25.722 7.02311L26.6938 4.43993C26.7154 4.35383 26.8666 4.35383 26.8882 4.43993L27.8601 7.02311C27.9248 7.13074 27.8385 7.28142 27.6873 7.28142Z",
        fill: "#302F38",
      },
      {
        d: "M36.3469 0.694336H34.2737C34.1009 0.694336 33.9497 0.845021 33.9497 1.01723V10.9624C33.9497 11.1347 34.1009 11.2853 34.2737 11.2853H36.3469C36.5197 11.2853 36.6709 11.1347 36.6709 10.9624V1.01723C36.6709 0.845021 36.5197 0.694336 36.3469 0.694336Z",
        fill: "#302F38",
      },
      {
        d: "M48.42 0.694336H46.3683C46.1956 0.694336 46.0444 0.845021 46.0444 1.01723V6.33426C46.0444 6.42037 45.9364 6.46342 45.8716 6.39884L41.5091 0.952652C41.3795 0.780441 41.1852 0.694336 40.9692 0.694336H39.3279C39.1551 0.694336 39.0039 0.845021 39.0039 1.01723V10.9624C39.0039 11.1347 39.1551 11.2853 39.3279 11.2853H41.3795C41.5523 11.2853 41.7035 11.1347 41.7035 10.9624V5.64541C41.7035 5.55931 41.8115 5.51626 41.8763 5.58083L46.2604 11.0055C46.3899 11.1777 46.5843 11.2638 46.8003 11.2638H48.4416C48.6144 11.2638 48.7656 11.1131 48.7656 10.9409V1.01723C48.744 0.845021 48.5928 0.694336 48.42 0.694336Z",
        fill: "#302F38",
      },
      {
        d: "M55.395 4.63307C54.1208 4.20254 53.6456 3.98728 53.6456 3.55675C53.6456 3.21233 54.0128 2.84638 54.9414 2.84638C55.8485 2.84638 56.3668 3.25538 56.518 3.70744C56.6044 3.94423 56.7123 4.07338 56.9715 4.07338H58.872C59.0664 4.07338 59.2392 3.87965 59.2176 3.68591C59.088 1.79159 57.3602 0.5 54.8766 0.5C52.4578 0.5 50.7301 1.77006 50.7301 3.79354C50.7301 5.98924 52.9545 6.78571 54.6391 7.3454C55.9133 7.77593 56.4532 8.05577 56.4532 8.50783C56.4532 8.83072 56.1292 9.15362 55.1142 9.15362C54.1639 9.15362 53.6024 8.83072 53.4081 8.46477C53.2353 8.18493 53.1705 8.12035 52.8681 8.12035H51.0324C50.8381 8.12035 50.6653 8.31409 50.6869 8.50783C50.8813 10.4452 52.7818 11.5 55.179 11.5C57.5978 11.5 59.4119 10.4237 59.4119 8.35714C59.3687 6.01076 56.8635 5.1497 55.395 4.63307Z",
        fill: "#302F38",
      },
      {
        d: "M69.6278 0.694336H60.946C60.7732 0.694336 60.6221 0.845021 60.6221 1.01723V2.99766C60.6221 3.16987 60.7732 3.32056 60.946 3.32056H63.6672C63.8184 3.32056 63.9479 3.44972 63.9479 3.6004V10.9624C63.9479 11.1347 64.0991 11.2853 64.2719 11.2853H66.3452C66.5179 11.2853 66.6691 11.1347 66.6691 10.9624V3.6004C66.6691 3.44972 66.7987 3.32056 66.9499 3.32056H69.671C69.8438 3.32056 69.995 3.16987 69.995 2.99766V1.01723C69.9734 0.845021 69.8222 0.694336 69.6278 0.694336Z",
        fill: "#302F38"
      },
      {
        d: "M79.4538 0.694336H71.9382C71.7654 0.694336 71.6143 0.845021 71.6143 1.01723V10.9624C71.6143 11.1347 71.7654 11.2853 71.9382 11.2853H79.4538C79.6266 11.2853 79.7778 11.1347 79.7778 10.9624V9.00354C79.7778 8.83133 79.6266 8.68064 79.4538 8.68064H74.6162C74.465 8.68064 74.3354 8.55148 74.3354 8.4008V7.58279C74.3354 7.43211 74.465 7.30295 74.6162 7.30295H78.482C78.6547 7.30295 78.8059 7.15226 78.8059 6.98005V5.17183C78.8059 4.99962 78.6547 4.84894 78.482 4.84894H74.6162C74.465 4.84894 74.3354 4.71978 74.3354 4.56909V3.6004C74.3354 3.44972 74.465 3.32056 74.6162 3.32056H79.4538C79.6266 3.32056 79.7778 3.16987 79.7778 2.99766V1.01723C79.7778 0.845021 79.6266 0.694336 79.4538 0.694336Z",
        fill: "#302F38"
      },
      {
        d: "M90.9651 11.0055L89.0214 8.2932C88.935 8.16404 88.9566 8.01336 89.1078 7.94878C90.382 7.25993 90.9651 5.94682 90.9651 4.5476C90.9651 2.43802 89.7125 0.672852 86.9913 0.672852H82.1321C81.9593 0.672852 81.8081 0.823536 81.8081 0.995748V10.9409C81.8081 11.1132 81.9593 11.2638 82.1321 11.2638H84.1837C84.3565 11.2638 84.5077 11.1132 84.5077 10.9409V8.7022C84.5077 8.55152 84.6373 8.42236 84.7884 8.42236H85.6307C85.8035 8.42236 85.9763 8.50846 86.0626 8.63762L87.7256 10.984C87.8552 11.1562 88.0495 11.2638 88.2439 11.2638H90.8355C90.9651 11.2854 91.0515 11.1347 90.9651 11.0055ZM86.8401 5.98987H84.7668C84.6157 5.98987 84.4861 5.86071 84.4861 5.71003V3.42823C84.4861 3.27755 84.6157 3.14839 84.7668 3.14839H86.8185C87.8984 3.14839 88.3087 3.75113 88.3087 4.56913C88.3303 5.32256 87.92 5.98987 86.8401 5.98987Z",
        fill: "#302F38"
      },
      {
        d: "M95 11.4236V0.576389H99.5536C100.036 0.576389 100.477 0.678241 100.877 0.881944C101.277 1.07546 101.625 1.34028 101.923 1.67639C102.22 2.00232 102.451 2.37407 102.615 2.79167C102.779 3.19907 102.861 3.61667 102.861 4.04444C102.861 4.63519 102.728 5.20046 102.461 5.74028C102.195 6.26991 101.82 6.70278 101.338 7.03889C100.856 7.36481 100.292 7.52778 99.6459 7.52778H96.3846V11.4236H95ZM96.3846 6.30556H99.569C99.9485 6.30556 100.277 6.2037 100.554 6C100.841 5.7963 101.061 5.5213 101.215 5.175C101.379 4.8287 101.461 4.45185 101.461 4.04444C101.461 3.61667 101.369 3.23472 101.184 2.89861C101 2.55231 100.759 2.28241 100.461 2.08889C100.164 1.89537 99.8357 1.79861 99.4767 1.79861H96.3846V6.30556Z",
        fill: "#302F38"
      },
      {
        d: "M105.354 11.4236V0.576389H106.739V10.2014H112.831V11.4236H105.354Z",
        fill: "#302F38"
      },
      {
        d: "M118.43 0.576389H119.599L124.061 11.4236H122.584L121.292 8.24583H116.707L115.43 11.4236H113.953L118.43 0.576389ZM120.984 7.17639L119.015 2.16528L116.984 7.17639H120.984Z",
        fill: "#302F38"
      },
      {
        d: "M133.128 1.79861H129.359V11.4236H127.974V1.79861H124.205V0.576389H133.128V1.79861Z",
        fill: "#302F38"
      },
      {
        d: "M135.47 11.4236V0.576389H142.685V1.79861H136.854V5.41944H141.762V6.56528H136.854V11.4236H135.47Z",
        fill: "#302F38"
      },
      {
        d: "M149.443 11.5C148.674 11.5 147.977 11.3472 147.351 11.0417C146.725 10.7361 146.182 10.3236 145.72 9.80417C145.269 9.27454 144.92 8.6838 144.674 8.03194C144.428 7.36991 144.305 6.69259 144.305 6C144.305 5.27685 144.433 4.58935 144.69 3.9375C144.956 3.27546 145.32 2.68981 145.782 2.18056C146.254 1.66111 146.802 1.2537 147.428 0.958333C148.054 0.652778 148.736 0.5 149.474 0.5C150.243 0.5 150.941 0.65787 151.566 0.973611C152.192 1.28935 152.73 1.71204 153.182 2.24167C153.633 2.7713 153.982 3.36204 154.228 4.01389C154.474 4.66574 154.597 5.33287 154.597 6.01528C154.597 6.73843 154.469 7.43102 154.212 8.09305C153.956 8.74491 153.592 9.33056 153.12 9.85C152.659 10.3593 152.115 10.7616 151.489 11.0569C150.864 11.3523 150.182 11.5 149.443 11.5ZM145.705 6C145.705 6.55 145.792 7.08472 145.967 7.60417C146.151 8.11343 146.408 8.56667 146.736 8.96389C147.064 9.36111 147.459 9.67685 147.92 9.91111C148.382 10.1454 148.895 10.2625 149.459 10.2625C150.043 10.2625 150.566 10.1403 151.028 9.89583C151.489 9.65139 151.879 9.32546 152.197 8.91805C152.525 8.51065 152.771 8.05231 152.935 7.54306C153.11 7.0338 153.197 6.51944 153.197 6C153.197 5.45 153.105 4.92037 152.92 4.41111C152.746 3.90185 152.489 3.44861 152.151 3.05139C151.823 2.64398 151.428 2.32824 150.966 2.10417C150.515 1.86991 150.013 1.75278 149.459 1.75278C148.874 1.75278 148.351 1.875 147.89 2.11944C147.428 2.3537 147.033 2.67454 146.705 3.08194C146.387 3.48935 146.141 3.94768 145.967 4.45694C145.792 4.95602 145.705 5.47037 145.705 6Z",
        fill: "#302F38"
      },
      {
        d: "M157.29 11.4236V0.576389H161.967C162.449 0.576389 162.89 0.678241 163.29 0.881944C163.69 1.07546 164.038 1.34028 164.336 1.67639C164.633 2.00232 164.864 2.37407 165.028 2.79167C165.192 3.19907 165.274 3.61667 165.274 4.04444C165.274 4.54352 165.177 5.01713 164.982 5.46528C164.797 5.91343 164.531 6.29537 164.182 6.61111C163.843 6.92685 163.443 7.14583 162.982 7.26806L165.628 11.4236H164.059L161.567 7.52778H158.674V11.4236H157.29ZM158.674 6.30556H161.982C162.361 6.30556 162.69 6.2037 162.966 6C163.254 5.78611 163.474 5.50602 163.628 5.15972C163.792 4.81343 163.874 4.44167 163.874 4.04444C163.874 3.63704 163.782 3.26528 163.597 2.92917C163.413 2.58287 163.172 2.30787 162.874 2.10417C162.577 1.90046 162.249 1.79861 161.89 1.79861H158.674V6.30556Z",
        fill: "#302F38"
      },
      {
        d: "M177.615 11.4236V3.14305L174.016 9.51389H173.169L169.554 3.14305V11.4236H168.17V0.576389H169.631L173.585 7.61944L177.554 0.576389H179V11.4236H177.615Z",
        fill: "#302F38"
      }
    ],
    width: 179,
    height: 12,
    viewBox: "0 0 179 12",
    fill: "none",
  },
  arrowRight: {
    paths: [
      {
        d: "M69.7081 8.31053C70.0998 7.92118 70.1017 7.28801 69.7123 6.89632L63.3675 0.513312C62.9781 0.121619 62.345 0.119721 61.9533 0.509073C61.5616 0.898425 61.5597 1.53159 61.949 1.92328L67.5889 7.59707L61.9151 13.2369C61.5234 13.6263 61.5215 14.2595 61.9109 14.6511C62.3002 15.0428 62.9334 15.0447 63.3251 14.6554L69.7081 8.31053ZM0.993096 8.39746L69.0001 8.6013L69.0061 6.60131L0.999091 6.39747L0.993096 8.39746Z",
        fill: "white",
      },
    ],
    width: 71,
    height: 15,
    viewBox: "0 0 71 15",
    fill: "none",
  },
  arrowRightSmall: {
    paths: [
      {
        d: "M1.5 4.58506C1.16863 4.58506 0.9 4.85369 0.9 5.18506C0.9 5.51643 1.16863 5.78506 1.5 5.78506L1.5 4.58506ZM10.4243 5.60932C10.6586 5.37501 10.6586 4.99511 10.4243 4.76079L6.60589 0.942419C6.37157 0.708105 5.99167 0.708105 5.75736 0.942419C5.52304 1.17673 5.52304 1.55663 5.75736 1.79095L9.15147 5.18506L5.75736 8.57917C5.52305 8.81349 5.52305 9.19339 5.75736 9.4277C5.99168 9.66202 6.37157 9.66202 6.60589 9.4277L10.4243 5.60932ZM1.5 5.78506L10 5.78506L10 4.58506L1.5 4.58506L1.5 5.78506Z",
        fill: "white",
      },
    ],
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
  },
  icnArrowSmallest: {
    paths: [
      {
        d: "M0.459778 1L6.37114 6.91136L12.2825 1",
        stroke: "black",
      },
    ],
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
  },
  icnArrowLongMedium: {
    paths: [
      {
        d: "M58.3536 4.35355C58.5489 4.15829 58.5489 3.8417 58.3536 3.64644L55.1716 0.464461C54.9764 0.269199 54.6598 0.269199 54.4645 0.464461C54.2692 0.659724 54.2692 0.976306 54.4645 1.17157L57.2929 3.99999L54.4645 6.82842C54.2692 7.02368 54.2692 7.34027 54.4645 7.53553C54.6598 7.73079 54.9764 7.73079 55.1716 7.53553L58.3536 4.35355ZM0.0488282 4.5L58 4.49999L58 3.49999L0.0488281 3.5L0.0488282 4.5Z",
        fill: "gray6",
      },
    ],
    with: 59,
    height: 8,
    viewBox: "0 0 59 8",
  },
  icnArrowLong: {
    paths: [
      {
        d: "M142.707 8.70564C143.098 8.31512 143.098 7.68195 142.707 7.29143L136.343 0.927467C135.953 0.536943 135.319 0.536943 134.929 0.927467C134.538 1.31799 134.538 1.95116 134.929 2.34168L140.586 7.99854L134.929 13.6554C134.538 14.0459 134.538 14.6791 134.929 15.0696C135.319 15.4601 135.953 15.4601 136.343 15.0696L142.707 8.70564ZM0 8.99854H142V6.99854H0V8.99854Z",
        fill: "black",
      },
    ],
    width: 143,
    height: 16,
    viewBox: "0 0 143 16",
    fill: "none",
  },
  icnArrowLeft: {
    paths: [
      {
        d: "M16.5 30.5L1.5 15.5L16.5 0.5",
        stroke: "gray5",
        strokeLineCap: "round",
        strokeWidth: "2.5",
      },
    ],
    width: 17,
    height: 31,
    viewBox: "0 0 17 31",
    fill: "none",
  },
  // icnArrowLeftTail: {
  //   d: ["M7 4.5C7.27614 4.5 7.5 4.27614 7.5 4C7.5 3.72386 7.27614 3.5 7 3.5V4.5ZM0.646447 3.64645C0.451184 3.84171 0.451184 4.15829 0.646447 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646447 3.64645ZM7 3.5H1V4.5H7V3.5Z"],
  //   width: 8,
  //   height: 8,
  //   viewBox: "0 0 8 8",
  //   fill: "#5D6174"
  // },
  icnCheck: {
    paths: [
      {
        d: "M8.41952 0.555261C8.6099 0.745642 8.6099 1.05431 8.41952 1.24469L3.1998 6.46441L0.25509 3.51969C0.0647095 3.32931 0.0647095 3.02064 0.25509 2.83026C0.445471 2.63988 0.754139 2.63988 0.944519 2.83026L3.1998 5.08555L7.73009 0.555261C7.92047 0.36488 8.22914 0.36488 8.41952 0.555261Z",
        fill: "white",
        clipRule: "evenodd",
        fillRule: "evenodd",
      },
    ],
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
  },
  icnClose: {
    paths: [
      {
        d: "M8.41952 0.555261C8.6099 0.745642 8.6099 1.05431 8.41952 1.24469L3.1998 6.46441L0.25509 3.51969C0.0647095 3.32931 0.0647095 3.02064 0.25509 2.83026C0.445471 2.63988 0.754139 2.63988 0.944519 2.83026L3.1998 5.08555L7.73009 0.555261C7.92047 0.36488 8.22914 0.36488 8.41952 0.555261Z",
      },
    ],
    d: [
      "M9.61838 7.5L14.5613 2.55711C15.1462 1.97214 15.1462 1.0237 14.5613 0.438731C13.9763 -0.146244 13.0279 -0.146243 12.4429 0.438731L7.5 5.38162L2.55711 0.438737C1.97214 -0.146238 1.0237 -0.146237 0.438731 0.438737C-0.146244 1.02371 -0.146243 1.97214 0.438731 2.55712L5.38162 7.5L0.438742 12.4429C-0.146234 13.0279 -0.146232 13.9763 0.438742 14.5613C1.02372 15.1462 1.97215 15.1462 2.55712 14.5613L7.5 9.61838L12.4429 14.5613C13.0279 15.1462 13.9763 15.1462 14.5613 14.5613C15.1462 13.9763 15.1462 13.0279 14.5613 12.4429L9.61838 7.5Z",
    ],
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
  },
  icnEyeOpen: {
    paths: [
      {
        d: "M0.078125 7.74888C2.48185 3.11357 6.94133 0 12.0455 0C17.1496 0 21.6091 3.11357 24.0128 7.74888C21.6091 12.3842 17.1496 15.4978 12.0455 15.4978C6.94133 15.4978 2.48185 12.3842 0.078125 7.74888ZM16.611 7.88019C16.611 10.7816 14.5259 13.1337 11.9539 13.1337C9.38191 13.1337 7.29688 10.7816 7.29688 7.88019C7.29688 4.97877 9.38191 2.62671 11.9539 2.62671C14.5259 2.62671 16.611 4.97877 16.611 7.88019ZM11.9534 11.0323C13.4966 11.0323 14.7476 9.62108 14.7476 7.88024C14.7476 6.13939 13.4966 4.72815 11.9534 4.72815C10.4102 4.72815 9.15918 6.13939 9.15918 7.88024C9.15918 9.62108 10.4102 11.0323 11.9534 11.0323Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#302F38",
      },
    ],
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
  },

  icnTime: {
    paths: [
      {
        d: "M4.88889 4.88889V3.11111M6.41422 6.44118L5 5.02696M9 5C9 7.20914 7.20914 9 5 9C2.79086 9 1 7.20914 1 5C1 2.79086 2.79086 1 5 1C7.20914 1 9 2.79086 9 5Z",
        stroke: "gray6",
        strokeWidth: "0.75",
        strokeLineCap: "round",
      },
    ],
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
  },
  icnUser: {
    paths: [
      {
        d: "M8.61175 8.625H0.38825C0.559455 6.21419 2.36731 4.375 4.5 4.375C6.63269 4.375 8.44055 6.21419 8.61175 8.625Z",
        stroke: "gray6",
        strokeWidth: "0.75",
      },
    ],
    circles: [
      {
        cx: "4.49999",
        cy: "2.91171",
        r: "2.27206",
        fill: "white",
        stroke: "gray6",
        strokeWidth: "0.75",
      },
    ],
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
  },
  icnMyProfile: {
    paths: [
      {
        d: "M7.2,7.2c1,0,1.8-0.4,2.6-1.1c0.7-0.7,1.1-1.6,1.1-2.6s-0.4-1.9-1.1-2.6C9,0.4,8.1,0,7.2,0S5.3,0.4,4.6,1.1 C3.9,1.8,3.5,2.6,3.5,3.6s0.4,1.9,1.1,2.6C5.3,6.9,6.2,7.2,7.2,7.2z",
        fill: "gray4",
      },
      {
        d: "M13.5,11.5c0-0.3-0.1-0.6-0.1-0.9c-0.1-0.3-0.1-0.7-0.2-1C13,9.3,12.9,9,12.7,8.7c-0.2-0.3-0.4-0.6-0.6-0.8 c-0.2-0.2-0.5-0.4-0.8-0.5c-0.3-0.1-0.7-0.2-1.1-0.2c-0.2,0-0.3,0.1-0.6,0.2C9.4,7.6,9.2,7.7,9,7.9C8.8,8,8.5,8.1,8.2,8.2 c-0.3,0.1-0.6,0.2-1,0.2c-0.3,0-0.6-0.1-1-0.2C6,8.1,5.7,8,5.5,7.9C5.3,7.7,5.1,7.6,4.9,7.5C4.6,7.3,4.4,7.2,4.3,7.2 c-0.4,0-0.8,0.1-1.1,0.2C2.9,7.6,2.6,7.8,2.4,8C2.1,8.2,1.9,8.4,1.8,8.7C1.6,9,1.5,9.3,1.4,9.6c-0.1,0.3-0.2,0.6-0.2,1 C1.1,10.9,1,11.2,1,11.5c0,0.3,0,0.6,0,0.9c0,0.8,0.2,1.4,0.7,1.9C2.2,14.8,2.9,15,3.6,15h7.2c0.8,0,1.4-0.2,1.9-0.7 c0.5-0.5,0.7-1.1,0.7-1.9C13.5,12.1,13.5,11.8,13.5,11.5z",
        fill: "gray4",
      },
    ],
    width: 14,
    heght: 15,
    viewBox: "0 0 14 15",
    style: "enable-background:new 0 0 14 15;",
  },
  icnSignOut: {
    paths: [
      {
        d: "M6,11.8c-0.1,0-0.1-0.1-0.2-0.1H2.8c-0.4,0-0.8-0.2-1.1-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V2.9 c0-0.4,0.2-0.8,0.4-1.1C2,1.5,2.3,1.3,2.8,1.3h2.8h0.1h0.1c0,0,0,0,0.1,0c0.1,0,0.1,0,0.1,0s0,0,0.1-0.1s0.1-0.1,0.1-0.1 c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.2-0.1-0.2C6,0,5.9,0,5.8,0H2.8 C2,0,1.3,0.3,0.8,0.9C0.3,1.4,0,2.1,0,2.9v7.2c0,0.8,0.3,1.5,0.8,2.1C1.3,12.7,2,13,2.8,13h3.1C5.9,13,6,13,6,12.9 c0.1-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2C6.1,11.9,6.1,11.8,6,11.8z",
        fill: "gray3",
      },
      {
        d: "M14.8,6L9.6,0.5C9.5,0.4,9.3,0.3,9.2,0.3C9,0.3,8.9,0.4,8.8,0.5S8.6,0.8,8.6,1v2.9H4.3C4.1,3.9,4,4,3.9,4.1 C3.7,4.2,3.7,4.4,3.7,4.6v3.9c0,0.2,0.1,0.3,0.2,0.5s0.3,0.2,0.4,0.2h4.3V12c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.4,0.2 c0.2,0,0.3-0.1,0.4-0.2L14.8,7C14.9,6.8,15,6.7,15,6.5C15,6.3,14.9,6.2,14.8,6z",
        fill: "gray3",
      },
    ],
    width: "15",
    height: "13",
    viewBox: "0 0 15 13",
    style: "enable-background:new 0 0 15 13;",
  },
  icnBriliant: {
    circles: [
      {
        cx: "19.3",
        cy: "19.3",
        r: 18.8,
        fill: "pink",
      },
    ],
    paths: [
      {
        d: "M19.5,32c-3.7,0-7-1.9-8.5-4.8c-0.4-0.8-0.4-1.8,0.1-2.6c0.5-0.8,1.4-1.3,2.4-1.3h12c1,0,1.9,0.5,2.4,1.3 c0.5,0.8,0.6,1.8,0.1,2.6C26.5,30.1,23.1,32,19.5,32z M13.5,24.6c-0.5,0-1,0.3-1.3,0.7c-0.3,0.4-0.3,1-0.1,1.4 c1.3,2.5,4.2,4.1,7.3,4.1c3.2,0,6.1-1.6,7.3-4.1c0.2-0.5,0.2-1-0.1-1.4c-0.3-0.4-0.8-0.7-1.3-0.7H13.5z",
        fill: "incorrect",
      },
      {
        d: "M11.6,20.5c-0.4,0-1-0.1-1.7-0.4c-1.2-0.5-2.3-1.1-3.2-1.9c-0.3-0.2-0.5-0.5-0.8-0.7c-1-0.9-2.5-2.8-1.9-4.7 c0.5-1.5,2.2-1.9,3.5-1.8c0.6,0.1,1.3,0.2,2,0.5l0.1,0c0.1,0,0.1,0.1,0.2,0.1c0.2-1.1,0.7-2,1.6-2.5C12.6,8.7,14,9,15,10 c1.1,1.2,1.4,2.9,0.7,5c-0.3,1.1-0.8,2.1-1.3,3.1c-0.1,0.1-0.1,0.2-0.2,0.3c-0.2,0.5-0.5,0.9-0.8,1.3C13,20.2,12.5,20.5,11.6,20.5z M7.3,12.4c-0.8,0-1.7,0.3-1.9,1c-0.4,1.3,1.1,3,1.6,3.4c0.2,0.2,0.4,0.4,0.7,0.6c0.8,0.6,1.7,1.2,2.9,1.7c1.3,0.6,1.8,0.1,1.9-0.1 c0.3-0.3,0.4-0.7,0.7-1.1c0.1-0.1,0.1-0.3,0.2-0.4c0.5-0.9,0.9-1.9,1.2-2.9c0.5-1.7,0.4-2.9-0.4-3.8c-0.5-0.5-1.2-0.9-2-0.5 c-0.8,0.4-1,1.4-1,1.9c0,0.3-0.2,0.6-0.5,0.8c-0.3,0.2-0.7,0.1-1-0.1c-0.2-0.1-0.3-0.2-0.5-0.3l-0.1,0c-0.5-0.2-1-0.4-1.5-0.4 C7.5,12.4,7.4,12.4,7.3,12.4z",
        fill: "incorrect",
      },
      {
        d: "M27.4,20.5c-0.8,0-1.4-0.4-1.7-0.8c-0.4-0.4-0.6-0.9-0.8-1.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-1-1-2-1.3-3.1 c-0.7-2.1-0.4-3.8,0.7-5c1-1,2.4-1.3,3.6-0.7c0.9,0.5,1.4,1.3,1.6,2.5c0.1,0,0.1-0.1,0.2-0.1l0.1,0c0.7-0.3,1.3-0.5,2-0.5 c1.3-0.1,3,0.3,3.5,1.8c0.6,1.9-0.9,3.7-1.9,4.7c-0.2,0.2-0.5,0.5-0.8,0.7c-0.9,0.7-1.9,1.3-3.2,1.9C28.4,20.4,27.8,20.5,27.4,20.5 z M26.2,10.2c-0.5,0-1,0.3-1.3,0.6c-0.8,0.9-1,2.1-0.4,3.8c0.3,1,0.7,2,1.2,2.9c0.1,0.1,0.1,0.3,0.2,0.4c0.2,0.4,0.4,0.8,0.7,1.1 c0.1,0.2,0.6,0.6,1.9,0.1c1.1-0.5,2.1-1,2.9-1.7c0.2-0.2,0.5-0.4,0.7-0.6c0.5-0.5,2-2.1,1.6-3.4c-0.3-0.8-1.5-1-2.2-0.9 c-0.5,0-1,0.2-1.5,0.4l-0.1,0c-0.2,0.1-0.4,0.2-0.5,0.3c-0.3,0.2-0.7,0.2-1,0.1c-0.3-0.2-0.5-0.5-0.5-0.8c0-0.5-0.2-1.5-1-1.9 C26.7,10.3,26.5,10.2,26.2,10.2z",
        fill: "incorrect",
      },
    ],
    viewBox: "0 0 38 38",
    width: 38,
    height: 38,
    style: "enable-background:new 0 0 38 38;",
  },
  icnConfusing: {
    circles: [
      {
        cx: "19.3",
        cy: "20.3",
        r: "18.8",
        fill: "yellow",
      },
    ],
    paths: [
      {
        d: "M25.8,31.1H12.2c-0.3,0-0.5-0.3-0.5-0.5s0.3-0.5,0.5-0.5h13.6c0.3,0,0.5,0.3,0.5,0.5S26.1,31.1,25.8,31.1z",
        fill: "black",
      },
      {
        d: "M10.6,23.3c-3.2,0-5.7-2.6-5.7-5.7c0-3.2,2.6-5.7,5.7-5.7c3.2,0,5.7,2.6,5.7,5.7C16.3,20.8,13.7,23.3,10.6,23.3 z M10.6,12.9c-2.6,0-4.6,2.1-4.6,4.7c0,2.6,2.1,4.7,4.7,4.7c2.6,0,4.7-2.1,4.7-4.7C15.2,15,13.1,12.9,10.6,12.9z",
        fill: "black",
      },
      {
        d: "M10.6,20.5c-1.6,0-2.9-1.3-2.9-2.9c0-1.6,1.3-2.9,2.9-2.9c1.6,0,2.9,1.3,2.9,2.9C13.4,19.2,12.2,20.5,10.6,20.5 z M10.6,15.8c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8S11.5,15.8,10.6,15.8z",
        fill: "black",
      },
      {
        d: "M27.4,23.3c-3.2,0-5.7-2.6-5.7-5.7c0-3.2,2.6-5.7,5.7-5.7c3.2,0,5.7,2.6,5.7,5.7C33.2,20.8,30.6,23.3,27.4,23.3 z M27.4,12.9c-2.6,0-4.7,2.1-4.7,4.7c0,2.6,2.1,4.7,4.7,4.7c2.6,0,4.7-2.1,4.7-4.7C32.1,15,30,12.9,27.4,12.9z",
        fill: "black",
      },
      {
        d: "M27.4,20.5c-1.6,0-2.9-1.3-2.9-2.9c0-1.6,1.3-2.9,2.9-2.9c1.6,0,2.9,1.3,2.9,2.9C30.3,19.2,29,20.5,27.4,20.5z M27.4,15.8c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8S28.4,15.8,27.4,15.8z",
        fill: "black",
      },
    ],
    style: "enable-background:new 0 0 38 40;",
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
  },
  icnHelpful: {
    circles: [
      {
        cx: "19.3",
        cy: "18.8",
        r: "18.8",
        fill: "green",
      },
    ],
    paths: [
      {
        d: "M8.5,18.5C7.1,18.5,6,17,6,15s1.1-3.5,2.5-3.5S11,13,11,15S9.9,18.5,8.5,18.5z M8.5,12.6c-0.6,0-1.3,1-1.3,2.4 s0.7,2.4,1.3,2.4s1.3-1,1.3-2.4S9.1,12.6,8.5,12.6z",
        fill: "beige",
      },
      {
        d: "M29.5,18.5C28.1,18.5,27,17,27,15s1.1-3.5,2.5-3.5S32,13,32,15S30.9,18.5,29.5,18.5z M29.5,12.6 c-0.6,0-1.3,1-1.3,2.4s0.7,2.4,1.3,2.4c0.6,0,1.3-1,1.3-2.4C30.8,13.6,30.1,12.6,29.5,12.6z",
        fill: "beige",
      },
      {
        d: "M19,31.5c-4.2,0-8-2-9.7-5c-0.5-0.8-0.4-1.9,0.2-2.7c0.6-0.8,1.6-1.3,2.6-1.3h13.8c1.1,0,2.1,0.5,2.6,1.3 c0.6,0.8,0.6,1.8,0.1,2.7C27,29.5,23.2,31.5,19,31.5z M12.1,23.6c-0.6,0-1.2,0.3-1.6,0.8c-0.3,0.5-0.4,1.1-0.1,1.6 c1.5,2.7,4.8,4.4,8.5,4.4s7.1-1.7,8.6-4.4c0.3-0.5,0.3-1.1-0.1-1.6c-0.3-0.5-0.9-0.8-1.6-0.8H12.1z",
        fill: "beige",
      },
    ],
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    style: "enable-background:new 0 0 38 38;",
  },
  icnInteresting: {
    circles: [
      {
        cx: "19.3",
        cy: "19.3",
        r: "18.8",
        fill: "blue",
      },
    ],
    paths: [
      {
        d: "M10,20.7c-1.4,0-2.5-1.7-2.5-3.8c0-2.1,1.1-3.9,2.5-3.9c1.4,0,2.5,1.7,2.5,3.8S11.4,20.7,10,20.7z M10,14.2 c-0.6,0-1.3,1.1-1.3,2.6c0,1.5,0.7,2.6,1.3,2.6c0.6,0,1.3-1.1,1.3-2.6S10.6,14.2,10,14.2z",
        fill: "gray7",
      },
      {
        d: "M30.2,21.7c-0.1,0-0.1,0-0.2,0l-5.7-2.1c-0.6-0.2-0.9-0.6-0.9-1c0-0.5,0.3-0.9,0.5-1l3.7-3.3 c0.2-0.2,0.6-0.2,0.8,0.1c0.2,0.3,0.2,0.6,0,0.9l-3.6,3.3l5.7,2.1c0.3,0.1,0.5,0.5,0.3,0.8C30.7,21.5,30.5,21.7,30.2,21.7z",
        fill: "gray7",
      },
      {
        d: "M19.2,30c-0.6,0-1.2,0-1.9-0.1c-0.3-0.1-0.6-0.4-0.5-0.7c0-0.3,0.3-0.6,0.7-0.5c4.8,0.6,9.8-1.3,13-4.9 c0.2-0.3,0.6-0.3,0.8,0c0.2,0.2,0.2,0.6,0,0.9C28.2,28,23.7,30,19.2,30z",
        fill: "gray7",
      },
    ],
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    style: "enable-background:new 0 0 38 38;",
  },
  icnPause: {
    paths: [
      {
        d: "M6.68459 1.5C3.6565 1.5 1.19629 3.97139 1.19629 7.02676C1.19629 10.0821 3.6565 12.5535 6.68459 12.5535C9.71269 12.5535 12.1729 10.0821 12.1729 7.02676C12.1729 3.97139 9.71269 1.5 6.68459 1.5ZM0.196289 7.02676C0.196289 3.42515 3.09819 0.5 6.68459 0.5C10.271 0.5 13.1729 3.42515 13.1729 7.02676C13.1729 10.6284 10.271 13.5535 6.68459 13.5535C3.09819 13.5535 0.196289 10.6284 0.196289 7.02676Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "gray3",
      },
      {
        d: "M4.68848 5.01794H5.68653V9.03578H4.68848V5.01794Z",
        fill: "gray3",
      },
      {
        d: "M7.68263 5.01794H8.68068V9.03578H7.68263V5.01794Z",
        fill: "gray3",
      },
    ],
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
  },
  icnPlay: {
    paths: [
      {
        d: "M6.9883 1.5C3.96021 1.5 1.5 3.97139 1.5 7.02676C1.5 10.0821 3.96021 12.5535 6.9883 12.5535C10.0164 12.5535 12.4766 10.0821 12.4766 7.02676C12.4766 3.97139 10.0164 1.5 6.9883 1.5ZM0.5 7.02676C0.5 3.42515 3.4019 0.5 6.9883 0.5C10.5747 0.5 13.4766 3.42515 13.4766 7.02676C13.4766 10.6284 10.5747 13.5535 6.9883 13.5535C3.4019 13.5535 0.5 10.6284 0.5 7.02676Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "gray3",
      },
      {
        d: "M10 7L5.5 9.59808L5.5 4.40192L10 7Z",
        fill: "gray3",
      },
    ],
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
  },
  icnCountdown: {
    paths: [
      {
        d: "M8,0.5c-3.2,0-5.9,2.4-6.4,5.4H0.9L2.1,8l1.2-2.1H2.6C3.1,3.4,5.3,1.5,8,1.5c3,0,5.5,2.5,5.5,5.5 S11,12.5,8,12.5c-1,0-2-0.3-2.9-0.8c-0.2-0.1-0.5-0.1-0.7,0.2c-0.1,0.2-0.1,0.5,0.2,0.7c1,0.6,2.2,0.9,3.4,0.9 c3.6,0,6.5-2.9,6.5-6.5S11.6,0.5,8,0.5z",
        fill: "gray3",
      },
      {
        d: "M7.6,3.4c-0.3,0-0.5,0.2-0.5,0.5v4h4c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5h-3v-3C8.1,3.6,7.9,3.4,7.6,3.4z",
        fill: "gray3",
      },
    ],
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    style: "enable-background:new 0 0 15 14;",
  },
  icnPoints: {
    paths: [
      {
        d: "M19 9.99275C14.054 10.0653 10.0653 14.054 10.0073 19C9.94923 14.054 5.94601 10.0508 1 9.99275C5.94601 9.93473 9.93473 5.94601 10.0073 1C10.0653 5.94601 14.054 9.93473 19 9.99275Z",
        stroke: "gray6",
        strokeWidth: "0.75",
      },
    ],
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
  },
  icnSearch: {
    paths: [
      {
        d: "M0.284837 17.301C-0.101187 17.696 -0.0939312 18.3291 0.301043 18.7152C0.696016 19.1012 1.32914 19.0939 1.71516 18.699L0.284837 17.301ZM16 7.53658C16 10.6161 13.566 13.0732 10.6115 13.0732V15.0732C14.7136 15.0732 18 11.6772 18 7.53658H16ZM10.6115 13.0732C7.65706 13.0732 5.22308 10.6161 5.22308 7.53658H3.22308C3.22308 11.6772 6.50952 15.0732 10.6115 15.0732V13.0732ZM5.22308 7.53658C5.22308 4.45708 7.65706 2 10.6115 2V0C6.50952 0 3.22308 3.39597 3.22308 7.53658H5.22308ZM10.6115 2C13.566 2 16 4.45708 16 7.53658H18C18 3.39597 14.7136 0 10.6115 0V2ZM6.00083 11.4525L0.284837 17.301L1.71516 18.699L7.43115 12.8504L6.00083 11.4525Z",
        fill: "gray3",
      },
    ],
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
  },
  icnStar: {
    paths: [
      {
        d: "M14.5 0L18.7614 8.63463L28.2903 10.0193L21.3952 16.7404L23.0229 26.2307L14.5 21.75L5.97711 26.2307L7.60484 16.7404L0.709681 10.0193L10.2386 8.63463L14.5 0Z",
        fill: "blue",
      },
    ],
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
  },
  icnStar7Stroked: {
    paths: [
      {
        d: "M14.3,8.5l-3.4-1.7l2.3-3.1c0.2-0.2,0.2-0.5,0-0.7c-0.2-0.2-0.4-0.3-0.7-0.2L9,4.4L8.1,0.7C8,0.4,7.8,0.2,7.5,0.2S7,0.4,6.9,0.7L6,4.4L2.5,2.8C2.3,2.7,2,2.8,1.8,3c-0.2,0.2-0.2,0.5,0,0.7l2.3,3.1L0.7,8.5C0.5,8.6,0.4,8.9,0.4,9.1C0.5,9.4,0.7,9.6,1,9.6l3.8,0.1L4,13.4C4,13.7,4.1,13.9,4.4,14c0.2,0.1,0.5,0.1,0.7-0.1l2.5-2.9l2.5,2.9c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.2,0,0.3-0.1c0.2-0.1,0.4-0.4,0.3-0.6l-0.8-3.8L14,9.6c0.3,0,0.5-0.2,0.5-0.4C14.6,8.9,14.5,8.6,14.3,8.5z M10,8.9C9.8,8.9,9.6,9,9.5,9.1S9.4,9.4,9.4,9.6l0.7,3.3l-2.1-2.6c-0.1-0.1-0.3-0.2-0.4-0.2s-0.3,0.1-0.4,0.2l-2.1,2.6l0.7-3.3c0-0.2,0-0.3-0.1-0.5S5.2,8.9,5,8.9L1.7,8.8l3-1.5C4.8,7.2,4.9,7.1,5,6.9s0-0.3-0.1-0.5l-2-2.7l3.1,1.4c0.2,0.1,0.3,0.1,0.5,0c0.2-0.1,0.3-0.2,0.3-0.4l0.8-3.2l0.8,3.2c0,0.2,0.2,0.3,0.3,0.4c0.2,0.1,0.3,0.1,0.5,0l3.1-1.4l-2,2.7C10,6.6,10,6.8,10,6.9c0,0.2,0.1,0.3,0.3,0.4l3,1.5L10,8.9z",
        fill: "blue",
      },
    ],
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
  },
  icnStar7Filled: {
    paths: [
      {
        d: "M14.3,8.5l-3.4-1.7l2.3-3.1c0.2-0.2,0.2-0.5,0-0.7c-0.2-0.2-0.4-0.3-0.7-0.2L9,4.4L8.1,0.7C8,0.4,7.8,0.2,7.5,0.2S7,0.4,6.9,0.7L6,4.4L2.5,2.8C2.3,2.7,2,2.8,1.8,3c-0.2,0.2-0.2,0.5,0,0.7l2.3,3.1L0.7,8.5C0.5,8.6,0.4,8.9,0.4,9.1C0.5,9.4,0.7,9.6,1,9.6l3.8,0.1L4,13.4C4,13.7,4.1,13.9,4.4,14c0.2,0.1,0.5,0.1,0.7-0.1l2.5-2.9l2.5,2.9c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.2,0,0.3-0.1c0.2-0.1,0.4-0.4,0.3-0.6l-0.8-3.8L14,9.6c0.3,0,0.5-0.2,0.5-0.4C14.6,8.9,14.5,8.6,14.3,8.5z",
        fill: "blue",
      },
    ],
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
  },
  icnStarBullet: {
    paths: [
      {
        d: "M20 10.2567L-4.76837e-08 10.2567L4.76837e-08 11.2567L20 11.2567L20 10.2567ZM10 20V0H9.00001V20H10ZM16.6667 2.92876L2.52453 17.0709L3.23164 17.778L17.3738 3.63586L16.6667 2.92876ZM16.6667 17.0712L2.52453 2.92911L1.81742 3.63621L15.9596 17.7784L16.6667 17.0712ZM19.1975 13.9332L0.612693 6.54361L0.243213 7.47285L18.828 14.8625L19.1975 13.9332ZM6.30512 19.2923L13.6947 0.707503L12.7655 0.338022L5.37588 18.9228L6.30512 19.2923ZM18.8075 5.89222L0.440873 13.8084L0.836682 14.7267L19.2033 6.81055L18.8075 5.89222ZM13.5822 19.034L5.66599 0.6673L4.74765 1.06311L12.6638 19.4298L13.5822 19.034Z",
        fill: "black",
      },
    ],
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
  },
  icnCommunity: {
    paths: [
      {
        d: "M35 14.3974L35.0147 15.3973L35.0117 13.3975L35 14.3974ZM21.9898 27.4286L20.9899 27.4403H22.9897L21.9898 27.4286ZM8.95864 14.3974L8.94691 13.3975V15.3974L8.95864 14.3974ZM21.9898 1.38724L22.9897 1.37551L20.9899 1.37258L21.9898 1.38724ZM12.5506 6.32141L12.5652 7.32131L12.5623 5.32148L12.5506 6.32141ZM6.71839 12.163L5.71846 12.1747H7.71833L6.71839 12.163ZM0.876831 6.32141L0.865102 5.32148V7.32135L0.876831 6.32141ZM6.71839 0.489258L7.71833 0.477528L5.7185 0.474597L6.71839 0.489258ZM34.9853 13.3975C27.2895 13.5104 21.0802 19.7176 20.9899 27.4169L22.9897 27.4403C23.0673 20.8284 28.3993 15.4943 35.0147 15.3973L34.9853 13.3975ZM22.9897 27.4169C22.8994 19.7182 16.6691 13.4878 8.97037 13.3975L8.94691 15.3974C15.5594 15.4749 20.9123 20.8278 20.9899 27.4403L22.9897 27.4169ZM8.97037 15.3974C16.6696 15.307 22.8769 9.09776 22.9897 1.4019L20.9899 1.37258C20.8929 7.98793 15.5589 13.3199 8.94691 13.3975L8.97037 15.3974ZM20.9899 1.39897C21.0802 9.09768 27.2896 15.3071 34.9883 15.3974L35.0117 13.3975C28.3992 13.3199 23.0673 7.98801 22.9897 1.37551L20.9899 1.39897ZM12.5359 5.32152C8.78795 5.37648 5.76247 8.3999 5.71846 12.1512L7.71833 12.1747C7.74958 9.51068 9.89778 7.36042 12.5652 7.32131L12.5359 5.32152ZM7.71833 12.1512C7.67433 8.40045 4.63935 5.36548 0.88856 5.32148L0.865102 7.32135C3.52968 7.3526 5.68721 9.51013 5.71846 12.1747L7.71833 12.1512ZM0.88856 7.32135C4.6399 7.27734 7.66333 4.25186 7.71829 0.503919L5.7185 0.474597C5.67939 3.14202 3.52913 5.29023 0.865102 5.32148L0.88856 7.32135ZM5.71846 0.500987C5.76246 4.25178 8.78803 7.27735 12.5388 7.32135L12.5623 5.32148C9.8977 5.29023 7.74958 3.14211 7.71833 0.477528L5.71846 0.500987Z",
        fill: "black",
      },
    ],
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
  },
  icnReset: {
    paths: [
      {
        d: "M16.6,8.7l-2.9-5l-2.9,5H13c-0.6,2.6-2.9,4.5-5.7,4.5c-3.2,0-5.8-2.6-5.8-5.8c0-3.2,2.6-5.8,5.8-5.8v-1c-3.8,0-6.8,3.1-6.8,6.8c0,3.8,3.1,6.8,6.8,6.8c3.3,0,6.1-2.4,6.7-5.5H16.6z",
        fill: "blue",
      },
    ],
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
  },
  icnChecked: {
    paths: [
      {
        d: "M6.3,14.3L0.7,8.4c-0.5-0.6,0-1.5,0.8-1.3l5,2c0.2,0.1,0.5,0,0.6-0.1l11-8.2c0.7-0.5,1.6,0.5,1,1.2L7.3,14.3C7,14.6,6.6,14.6,6.3,14.3z",
        fill: "success",
      },
    ],
    viewBox: "0 0 19.5 15",
    width: 19.5,
    height: 15,
  },
  icnX: {
    paths: [
      {
        d: "M9.5,7.5l4.2-4.2c0.6-0.6,0.6-1.5,0-2c-0.6-0.6-1.5-0.6-2,0L7.5,5.5L3.3,1.2c-0.6-0.6-1.5-0.6-2,0c-0.6,0.6-0.6,1.5,0,2l4.2,4.2l-4.2,4.2c-0.6,0.6-0.6,1.5,0,2c0.3,0.3,0.7,0.4,1,0.4c0.4,0,0.7-0.1,1-0.4l4.2-4.2l4.2,4.2c0.3,0.3,0.7,0.4,1,0.4c0.4,0,0.7-0.1,1-0.4c0.6-0.6,0.6-1.5,0-2L9.5,7.5z",
        fill: "coralRed",
      },
    ],
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
  },
  icnXMobile: {
    paths: [
      {
        d: "M17.1,12.6L12,7l4.9-5.6c0.3-0.2,0.2-0.6,0-0.8c-0.2-0.3-0.6-0.2-0.8,0L11,6.2L5.8,0.6C5.6,0.4,5.2,0.4,5,0.6S4.8,1.2,5,1.4L10.1,7l-5,5.6c-0.3,0.2-0.2,0.6,0,0.8c0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2L11,7.8l5.2,5.6c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.3-0.1,0.5-0.2C17.3,13.2,17.3,12.8,17.1,12.6z",
        fill: "blue",
      },
    ],
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
  },
  icnRemove: {
    paths: [
      {
        d: "M1.6,3.5c-0.3,0-0.6,0-0.9,0c-0.1,0-0.2,0-0.3,0C0.1,3.4,0,3.2,0,2.9c0-0.3,0.2-0.5,0.5-0.5c0.1,0,0.1,0,0.2,0 c0.9,0,1.9,0,2.8,0c0.1,0,0.2,0,0.2,0c0-0.2,0-0.5,0.1-0.7C4,0.8,4.7,0.2,5.6,0.2c1.3,0,2.6,0,3.9,0c1,0,1.8,0.8,1.8,1.8 c0,0.1,0,0.2,0,0.3c0.1,0,0.2,0,0.3,0c0.9,0,1.9,0,2.8,0c0.1,0,0.2,0,0.3,0C14.9,2.5,15,2.7,15,3c0,0.2-0.2,0.4-0.4,0.5 c-0.1,0-0.2,0-0.3,0c-0.3,0-0.6,0-0.9,0c0,0.1,0,0.2,0,0.3c0,3.9,0,7.9,0,11.8c0,0.9-0.5,1.6-1.3,1.9c-0.2,0.1-0.4,0.1-0.6,0.1 c-2.7,0-5.3,0-8,0c-1.1,0-1.9-0.8-1.9-2c0-2.3,0-4.6,0-6.8c0-1.7,0-3.4,0-5.1C1.6,3.7,1.6,3.6,1.6,3.5z M12.3,3.5 c-0.3-0.1-9.4,0-9.6,0c0,0.1,0,0.1,0,0.2c0,2.2,0,4.4,0,6.6c0,1.5,0,3,0,4.5c0,0.3,0,0.6,0,0.9c0,0.4,0.3,0.7,0.8,0.7 c2.7,0,5.4,0,8.1,0c0.4,0,0.7-0.3,0.8-0.7c0-0.1,0-0.2,0-0.3c0-2.4,0-4.7,0-7.1c0-1.5,0-3.1,0-4.6C12.3,3.7,12.3,3.6,12.3,3.5z M10.1,2.4c0.1-0.6-0.3-1.1-0.8-1.1c-1.2,0-2.4,0-3.7,0c-0.1,0-0.3,0-0.4,0.1C5,1.5,4.8,1.9,4.9,2.4C6.6,2.4,8.4,2.4,10.1,2.4z",
        fill: "gray3",
      },
      {
        d: "M10.7,10c0,1.4,0,2.8,0,4.2c0,0.1,0,0.2-0.1,0.3c-0.1,0.2-0.3,0.3-0.5,0.3c-0.2,0-0.4-0.2-0.5-0.4 c0-0.1,0-0.2,0-0.3c0-2.8,0-5.6,0-8.4c0-0.1,0-0.2,0-0.3c0.1-0.3,0.3-0.4,0.6-0.4c0.3,0,0.5,0.2,0.5,0.5c0,0.1,0,0.1,0,0.2 C10.7,7.2,10.7,8.6,10.7,10z",
        fill: "gray3",
      },
      {
        d: "M4.3,10c0-1.4,0-2.8,0-4.2c0-0.1,0-0.1,0-0.2c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.1,0.6,0.4c0,0.1,0,0.2,0,0.3 c0,1,0,2,0,2.9c0,1.8,0,3.6,0,5.4c0,0.1,0,0.2,0,0.3c-0.1,0.3-0.3,0.5-0.6,0.4c-0.3,0-0.5-0.2-0.5-0.5c0-0.1,0-0.1,0-0.2 C4.3,12.8,4.3,11.4,4.3,10z",
        fill: "gray3",
      },
      {
        d: "M8,10c0,1.4,0,2.9,0,4.3c0,0.3-0.1,0.5-0.4,0.6C7.3,15,7,14.7,7,14.4c0-0.1,0-0.1,0-0.2c0-2.8,0-5.6,0-8.4 c0-0.1,0-0.1,0-0.2c0-0.3,0.3-0.5,0.5-0.5C7.8,5.1,8,5.3,8,5.6c0,0.1,0,0.1,0,0.2C8,7.2,8,8.6,8,10z",
        fill: "gray3",
      },
    ],
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    style: "enable-background:new 0 0 15 18;",
  },
  icnEdit: {
    paths: [
      {
        d: "M9.85562 5.99876C9.61959 5.99876 9.42624 6.18959 9.42624 6.42813V10.7144C9.42624 10.9504 9.2354 11.1438 8.99686 11.1438H1.28562C1.04959 11.1438 0.856246 10.9529 0.856246 10.7144V2.14188C0.856246 1.90585 1.04708 1.7125 1.28562 1.7125H6.42812C6.66416 1.7125 6.8575 1.52167 6.8575 1.28313C6.8575 1.04458 6.66667 0.853747 6.42812 0.853747H1.28562C0.575016 0.856258 0 1.43378 0 2.14188V10.7119C0 11.4225 0.575016 11.9975 1.28562 11.9975H8.99937C9.70998 11.9975 10.285 11.4225 10.285 10.7119V6.42813C10.285 6.1921 10.0942 5.99876 9.85562 5.99876Z",
        fill: "black",
      },
      {
        d: "M11.5179 0.479625C11.2116 0.173285 10.7947 2.69181e-05 10.3578 2.69181e-05C9.92342 -0.00248407 9.50409 0.170774 9.19775 0.479625L3.55305 6.12432C3.50535 6.17203 3.47019 6.22978 3.4501 6.29256L2.59386 8.86381C2.51853 9.08728 2.64157 9.33085 2.86504 9.40618C2.90773 9.42124 2.95544 9.42878 3.00064 9.42878C3.04584 9.42878 3.09354 9.42124 3.13623 9.40618L5.70748 8.54993C5.77025 8.52984 5.82801 8.49218 5.87572 8.44698L11.5204 2.80229C12.1607 2.15947 12.1607 1.12244 11.5179 0.479625ZM10.9128 2.19463L5.34088 7.7665L3.67609 8.32143L4.23102 6.65916L9.80541 1.08728C10.1117 0.780943 10.6089 0.780943 10.9128 1.08728C11.0584 1.23292 11.1413 1.43129 11.1413 1.6397C11.1438 1.84811 11.0609 2.04899 10.9128 2.19463Z",
        fill: "black",
      },
    ],
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
  },
  icnFilter: {
    paths: [
      {
        d: "M11.2,0.7H1.9c-1.4,0-2.1,1.6-1.2,2.6l3.9,4.6v4.8v1.1l0.9-0.6l2.9-1.9l-0.3-0.5l0,0l0.3,0.5l0.3-0.2v-0.3V7.7l3.7-4.4C13.3,2.3,12.6,0.7,11.2,0.7z M7.7,7.1L7.5,7.2v0.2v3l-1.7,1.1V7.7V7.5L5.6,7.3L1.6,2.5c-0.2-0.3,0-0.7,0.3-0.7h9.3c0.3,0,0.5,0.4,0.3,0.7L7.7,7.1z",
        fill: "blue",
      },
    ],
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
  },
  icnCamera: {
    paths: [
      {
        d: "M17.6108 3.63802H14.744V3.31948C14.744 1.99226 13.6822 0.930481 12.355 0.930481H7.78934C6.46211 0.930481 5.40034 1.99226 5.40034 3.31948V3.63802H2.53353C1.20631 3.63802 0.144531 4.6998 0.144531 6.02702V14.6805C0.144531 16.0077 1.20631 17.0695 2.53353 17.0695H17.6108C18.938 17.0695 19.9998 16.0077 19.9998 14.6805V6.02702C19.9998 4.6998 18.938 3.63802 17.6108 3.63802ZM10.0722 14.5743C7.57698 14.5743 5.5596 12.557 5.5596 10.0618C5.5596 7.5666 7.57698 5.54922 10.0722 5.54922C12.5673 5.54922 14.5847 7.5666 14.5847 10.0618C14.5847 12.557 12.5673 14.5743 10.0722 14.5743ZM12.4612 10.0618C12.4612 11.389 11.3994 12.4508 10.0722 12.4508C8.74494 12.4508 7.68316 11.389 7.68316 10.0618C7.68316 8.73455 8.74494 7.67278 10.0722 7.67278C11.3994 7.67278 12.4612 8.73455 12.4612 10.0618Z",
        fill: "white",
      },
    ],
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
  },
  icnSend: {
    paths: [
      {
        d: "M31.4754 0.930686C31.4196 0.85627 31.3638 0.788055 31.2955 0.71984C31.2955 0.713639 31.2893 0.713639 31.2893 0.707438L31.2831 0.701236C30.9234 0.347759 30.4272 0.155518 29.8503 0.155518C29.5216 0.155518 29.1681 0.217531 28.8021 0.341558L1.87076 9.31491C0.444179 9.79241 0.183673 10.6172 0.158863 11.0699C0.12785 11.5226 0.289116 12.3784 1.64127 13.0233L8.40202 16.2542L5.37518 23.7268C5.36898 23.7454 5.36278 23.7641 5.35658 23.7827C5.02164 24.7935 5.1581 25.6989 5.72873 26.2694C6.09468 26.6353 6.59708 26.8213 7.17392 26.8213C7.50265 26.8213 7.84999 26.7593 8.21594 26.6415C8.23455 26.6353 8.25315 26.6291 8.27176 26.6229L15.7458 23.5966L18.9773 30.3561C19.5976 31.646 20.4101 31.8444 20.8381 31.8444C21.2226 31.8444 22.1716 31.677 22.6864 30.1266L31.6615 3.20038C31.9592 2.31359 31.891 1.50741 31.4754 0.930686ZM2.16228 11.1939C2.23671 11.1567 2.32975 11.1133 2.4538 11.0761L28.1881 2.49963L13.668 17.017C13.1407 16.5705 12.5825 16.1984 12.0615 15.9442L2.43519 11.349C2.32354 11.2931 2.23051 11.2435 2.16228 11.1939ZM7.60189 24.8927C7.27936 24.9981 7.09949 24.9795 7.04366 24.9609C7.02506 24.9051 7.00645 24.7191 7.11189 24.4028L10.0829 17.0666L11.2614 17.6309C12.384 18.1704 13.8416 19.6216 14.3812 20.7502L14.9457 21.9285L7.60189 24.8927ZM20.9249 29.5437C20.8815 29.6677 20.8443 29.7608 20.8071 29.8352C20.7636 29.767 20.7078 29.6739 20.652 29.5623L16.0559 19.9378C15.8078 19.4107 15.4295 18.8588 14.9829 18.3317L29.503 3.81431L20.9249 29.5437Z",
        fill: "white",
      },
    ],
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
  },
  icnMobile: {
    paths: [
      {
        d: "M11.869 0.625H2.13105C1.1996 0.625 0.4375 1.34352 0.4375 2.22172V20.9033C0.4375 21.7815 1.1996 22.5 2.13105 22.5H11.869C12.8004 22.5 13.5625 21.7815 13.5625 20.9033V2.22172C13.5625 1.34352 12.8004 0.625 11.869 0.625ZM4.58669 1.58303H9.41331C9.49798 1.58303 9.66734 1.7427 9.66734 1.98221C9.66734 2.22172 9.58266 2.38139 9.41331 2.38139H4.58669C4.50202 2.38139 4.41734 2.22172 4.41734 1.98221C4.41734 1.7427 4.50202 1.58303 4.58669 1.58303ZM7.04234 20.9831C6.4496 20.9831 5.94153 20.5041 5.94153 19.9453C5.94153 19.3864 6.4496 18.9074 7.04234 18.9074C7.63508 18.9074 8.14315 19.3864 8.14315 19.9453C8.14315 20.5041 7.63508 20.9831 7.04234 20.9831ZM12.2923 17.4703H1.70766V3.33942H12.2923V17.4703Z",
        fill: "white",
      },
    ],
    width: 14,
    height: 23,
    viewBox: "0 0 14 23",
  },
  icnBell: {
    paths: [
      {
        d: "M16.4202 8.30665C16.1003 8.30665 15.8406 8.04701 15.8406 7.7271C15.8406 5.50781 14.9768 3.42224 13.4081 1.85282C13.1817 1.62643 13.1817 1.2594 13.4081 1.03302C13.6345 0.806632 14.0015 0.806632 14.2281 1.03302C16.0154 2.82104 16.9997 5.1988 16.9997 7.7271C16.9997 8.04701 16.7401 8.30665 16.4202 8.30665Z",
        fill: "darkBlack",
      },
      {
        d: "M0.579547 8.30666C0.259636 8.30666 0 8.04702 0 7.72711C0 5.19881 0.984495 2.82105 2.77252 1.03373C2.9989 0.807349 3.36607 0.807349 3.59246 1.03373C3.81884 1.26012 3.81884 1.62729 3.59246 1.85368C2.02304 3.42224 1.15909 5.50782 1.15909 7.72711C1.15909 8.04702 0.899459 8.30666 0.579547 8.30666Z",
        fill: "darkBlack",
      },
      {
        d: "M8.49994 18.5456C6.90194 18.5456 5.60221 17.2459 5.60221 15.6479C5.60221 15.328 5.86184 15.0683 6.18176 15.0683C6.50167 15.0683 6.7613 15.328 6.7613 15.6479C6.7613 16.6069 7.54092 17.3865 8.49994 17.3865C9.45883 17.3865 10.2386 16.6069 10.2386 15.6479C10.2386 15.328 10.4982 15.0683 10.8181 15.0683C11.138 15.0683 11.3977 15.328 11.3977 15.6479C11.3977 17.2459 10.0979 18.5456 8.49994 18.5456Z",
        fill: "darkBlack",
      },
      {
        d: "M14.875 16.2272H2.12494C1.37914 16.2272 0.77257 15.6206 0.77257 14.875C0.77257 14.4792 0.944906 14.1046 1.24557 13.8472C2.4208 12.8542 3.09076 11.4108 3.09076 9.88161V7.72713C3.09076 4.7445 5.51719 2.31807 8.49996 2.31807C11.4826 2.31807 13.909 4.7445 13.909 7.72713V9.88161C13.909 11.4108 14.579 12.8542 15.7466 13.8418C16.0549 14.1046 16.2272 14.4792 16.2272 14.875C16.2272 15.6206 15.6206 16.2272 14.875 16.2272ZM8.49996 3.47716C6.15616 3.47716 4.24985 5.38347 4.24985 7.72713V9.88161C4.24985 11.7523 3.43005 13.5188 2.00128 14.7265C1.97425 14.7498 1.93166 14.7977 1.93166 14.875C1.93166 14.98 2.01981 15.0681 2.12494 15.0681H14.875C14.98 15.0681 15.0681 14.98 15.0681 14.875C15.0681 14.7977 15.0257 14.7498 15.0001 14.7281C13.5697 13.5188 12.7499 11.7523 12.7499 9.88161V7.72713C12.7499 5.38347 10.8436 3.47716 8.49996 3.47716Z",
        fill: "darkBlack",
      },
      {
        d: "M8.49996 3.47716C8.18005 3.47716 7.92064 3.21765 7.92064 2.89774V0.579547C7.92064 0.259636 8.18027 0 8.50018 0C8.82009 0 9.07973 0.259636 9.07973 0.579547V2.89774C9.07973 3.21765 8.81987 3.47716 8.49996 3.47716Z",
        fill: "darkBlack",
      },
    ],
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
  },
  icnBulb: {
    paths: [
      {
        d: "M9.0007 2.10894C9.29194 2.10894 9.52804 2.34504 9.52804 2.63628C9.52804 2.92751 9.29194 3.16362 9.0007 3.16362C7.25576 3.16362 5.83611 4.58302 5.83611 6.32769C5.83611 6.61892 5.60001 6.85503 5.30877 6.85503C5.01754 6.85503 4.78143 6.61892 4.78143 6.32769C4.78143 4.00147 6.67417 2.10894 9.0007 2.10894Z",
        fill: "darkBlack",
      },
      {
        d: "M10.3592 0.141752C12.7417 0.6396 14.6736 2.55294 15.1819 4.95028C15.6111 6.97465 15.0822 9.00703 13.7307 10.5263C13.0701 11.2689 12.6913 12.2492 12.6913 13.2185V14.2732C12.6913 14.9749 12.2319 15.571 11.5982 15.7775C11.3898 17.0088 10.321 17.9997 8.99987 17.9997C7.67909 17.9997 6.61006 17.0092 6.40158 15.7775C5.76785 15.571 5.30847 14.9749 5.30847 14.2731V13.2184C5.30847 12.2472 4.92836 11.2788 4.23824 10.4914C3.22806 9.33898 2.67175 7.86031 2.67175 6.32785C2.67175 2.33533 6.3262 -0.700802 10.3592 0.141752ZM8.99987 16.945C9.67776 16.945 10.2721 16.4786 10.4916 15.8517H7.50819C7.72764 16.4786 8.32199 16.945 8.99987 16.945ZM6.36315 14.2732C6.36315 14.5639 6.59972 14.8005 6.8905 14.8005H11.1092C11.4 14.8005 11.6366 14.5639 11.6366 14.2732V13.7458H6.36315V14.2732ZM5.03137 9.79626C5.76683 10.6353 6.21933 11.6471 6.33415 12.6911H11.6655C11.7802 11.6466 12.2315 10.6248 12.9426 9.82533C14.069 8.55914 14.5091 6.86198 14.1501 5.16906C13.7311 3.19279 12.1209 1.58738 10.1434 1.17419C6.76759 0.468705 3.72643 3.00389 3.72643 6.32785C3.72643 7.60444 4.18987 8.83621 5.03137 9.79626Z",
        fill: "darkBlack",
      },
      {
        d: "M16.418 6.32769H17.4727C17.7639 6.32769 18 6.5638 18 6.85503C18 7.14627 17.7639 7.38238 17.4727 7.38238H16.418C16.1267 7.38238 15.8906 7.14627 15.8906 6.85503C15.8906 6.5638 16.1267 6.32769 16.418 6.32769Z",
        fill: "darkBlack",
      },
      {
        d: "M16.1994 3.69096L16.9452 2.94519C17.1511 2.73925 17.485 2.73925 17.6909 2.94519C17.8969 3.15114 17.8969 3.48502 17.6909 3.69096L16.9452 4.43673C16.7393 4.64268 16.4054 4.64271 16.1994 4.43673C15.9935 4.23079 15.9935 3.89691 16.1994 3.69096Z",
        fill: "darkBlack",
      },
      {
        d: "M16.1994 9.27328C16.4054 9.06734 16.7393 9.06734 16.9452 9.27328L17.6909 10.0191C17.8969 10.225 17.8969 10.5589 17.6909 10.7648C17.485 10.9708 17.1511 10.9708 16.9452 10.7648L16.1994 10.0191C15.9935 9.81311 15.9935 9.47923 16.1994 9.27328Z",
        fill: "darkBlack",
      },
      {
        d: "M0.527344 6.32769H1.58203C1.87327 6.32769 2.10938 6.5638 2.10938 6.85503C2.10938 7.14627 1.87327 7.38238 1.58203 7.38238H0.527344C0.236109 7.38238 0 7.14627 0 6.85503C0 6.5638 0.236109 6.32769 0.527344 6.32769Z",
        fill: "darkBlack",
      },
      {
        d: "M0.308787 2.94519C0.514697 2.73925 0.848612 2.73925 1.05456 2.94519L1.80033 3.69096C2.00627 3.89691 2.00627 4.23079 1.80033 4.43673C1.59442 4.64264 1.2605 4.64268 1.05456 4.43673L0.308787 3.69096C0.102841 3.48502 0.102841 3.15114 0.308787 2.94519Z",
        fill: "darkBlack",
      },
      {
        d: "M0.308787 10.0191L1.05456 9.27328C1.26047 9.06734 1.59438 9.06734 1.80033 9.27328C2.00627 9.47923 2.00627 9.81311 1.80033 10.0191L1.05456 10.7648C0.848647 10.9707 0.514732 10.9708 0.308787 10.7648C0.102841 10.5589 0.102841 10.225 0.308787 10.0191Z",
        fill: "darkBlack",
      },
    ],
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
  },
  icnLink: {
    paths: [
      {
        d: "M10.1237 17.7666L7.53261 20.3576C6.45838 21.4319 4.71812 21.4319 3.64388 20.3576C2.56965 19.2834 2.56965 17.5431 3.64388 16.4689L8.83028 11.2825C9.90452 10.2083 11.6448 10.2083 12.719 11.2825C13.0757 11.6391 13.6557 11.6391 14.0167 11.2825C14.3733 10.9259 14.3733 10.3458 14.0167 9.98482C12.2249 8.193 9.32443 8.193 7.53691 9.98482L2.34191 15.1755C0.550092 16.9673 0.550092 19.8678 2.34191 21.6553C4.12944 23.4471 7.03417 23.4471 8.82599 21.6553L11.417 19.0642C11.7737 18.7076 11.7737 18.1275 11.417 17.7666C11.0604 17.4056 10.4803 17.4099 10.1237 17.7666Z",
        fill: "gray4",
      },
      {
        d: "M21.6556 2.34057C19.8638 0.548749 16.9634 0.548749 15.1715 2.34057L12.0606 5.45155C11.7039 5.8082 11.7039 6.38828 12.0606 6.74923C12.4172 7.10587 12.9973 7.10587 13.3582 6.74923L16.4692 3.63824C17.5435 2.56401 19.2837 2.56401 20.3579 3.63824C21.4322 4.71248 21.4322 6.45274 20.3579 7.52697L14.6559 13.229C13.5817 14.3032 11.8414 14.3032 10.7672 13.229C10.4105 12.8724 9.83046 12.8724 9.46951 13.229C9.10857 13.5856 9.11287 14.1657 9.46951 14.5267C11.2613 16.3185 14.1618 16.3185 15.9493 14.5267L21.6513 8.82465C23.4474 7.03282 23.4474 4.13239 21.6556 2.34057Z",
        fill: "gray4",
      },
    ],
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
  },
  icnFacebookCircled: {
    paths: [
      {
        d: "M16 0C7.164 0 0 7.164 0 16C0 24.836 7.164 32 16 32C24.836 32 32 24.836 32 16C32 7.164 24.836 0 16 0ZM20 10.6667H18.2C17.4827 10.6667 17.3333 10.9613 17.3333 11.704V13.3333H20L19.7213 16H17.3333V25.3333H13.3333V16H10.6667V13.3333H13.3333V10.256C13.3333 7.89733 14.5747 6.66667 17.372 6.66667H20V10.6667Z",
        fill: "#danger_select",
      },
    ],
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
  },
  icnLinkedInCircled: {
    paths: [
      {
        d: "M16 0C7.164 0 0 7.164 0 16C0 24.836 7.164 32 16 32C24.836 32 32 24.836 32 16C32 7.164 24.836 0 16 0ZM13.3333 21.3333H10.6667V13.3333H13.3333V21.3333ZM12 12.1453C11.1907 12.1453 10.5333 11.484 10.5333 10.6667C10.5333 9.85067 11.1893 9.188 12 9.188C12.8107 9.188 13.4667 9.85067 13.4667 10.6667C13.4667 11.484 12.8093 12.1453 12 12.1453ZM22.6667 21.3333H20.0027V17.5187C20.0027 15.0107 17.3333 15.2227 17.3333 17.5187V21.3333H14.6667V13.3333H17.3333V14.7907C18.496 12.636 22.6667 12.476 22.6667 16.8547V21.3333Z",
        fill: "danger_select",
      },
    ],
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
  },
  icnInstagramCircled: {
    paths: [
      {
        d: "M19.772 8.40267C18.788 8.35733 18.492 8.34933 16 8.34933C13.508 8.34933 13.2133 8.35867 12.2293 8.40267C9.69733 8.51867 8.51867 9.71733 8.40267 12.2293C8.35867 13.2133 8.348 13.508 8.348 16C8.348 18.492 8.35867 18.7867 8.40267 19.772C8.51867 22.2773 9.692 23.4827 12.2293 23.5987C13.212 23.6427 13.508 23.6533 16 23.6533C18.4933 23.6533 18.788 23.644 19.772 23.5987C22.304 23.484 23.4813 22.2813 23.5987 19.772C23.6427 18.788 23.652 18.492 23.652 16C23.652 13.508 23.6427 13.2133 23.5987 12.2293C23.4813 9.71867 22.3013 8.51867 19.772 8.40267V8.40267ZM16 20.7933C13.3533 20.7933 11.2067 18.648 11.2067 16C11.2067 13.3533 13.3533 11.208 16 11.208C18.6467 11.208 20.7933 13.3533 20.7933 16C20.7933 18.6467 18.6467 20.7933 16 20.7933ZM20.9827 12.1387C20.364 12.1387 19.8627 11.6373 19.8627 11.0187C19.8627 10.4 20.364 9.89867 20.9827 9.89867C21.6013 9.89867 22.1027 10.4 22.1027 11.0187C22.1027 11.636 21.6013 12.1387 20.9827 12.1387V12.1387ZM19.1107 16C19.1107 17.7187 17.7173 19.1107 16 19.1107C14.2827 19.1107 12.8893 17.7187 12.8893 16C12.8893 14.2813 14.2827 12.8893 16 12.8893C17.7173 12.8893 19.1107 14.2813 19.1107 16ZM16 0C7.164 0 0 7.164 0 16C0 24.836 7.164 32 16 32C24.836 32 32 24.836 32 16C32 7.164 24.836 0 16 0ZM25.2773 19.848C25.124 23.2413 23.2347 25.1213 19.8493 25.2773C18.8533 25.3227 18.5347 25.3333 16 25.3333C13.4653 25.3333 13.148 25.3227 12.152 25.2773C8.76 25.1213 6.87867 23.2387 6.72267 19.848C6.67733 18.8533 6.66667 18.5347 6.66667 16C6.66667 13.4653 6.67733 13.148 6.72267 12.152C6.87867 8.76 8.76133 6.87867 12.152 6.724C13.148 6.67733 13.4653 6.66667 16 6.66667C18.5347 6.66667 18.8533 6.67733 19.8493 6.724C23.2427 6.88 25.1253 8.76667 25.2773 12.152C25.3227 13.148 25.3333 13.4653 25.3333 16C25.3333 18.5347 25.3227 18.8533 25.2773 19.848Z",
        fill: "danger_select",
      },
    ],
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
  },
  icnYouTubeCircled: {
    paths: [
      {
        d: "M15.9996 32.3042C7.15773 32.3042 0 25.1465 0 16.3045C0 7.37844 7.15773 0.220703 15.9996 0.220703C24.8415 0.220703 31.9993 7.37844 31.9993 16.2203C32.0835 25.0622 24.8415 32.3042 15.9996 32.3042Z",
        fill: "white",
      },
      {
        d: "M26.5738 11.0519C26.2903 10.1303 25.5813 9.35048 24.6597 9.13781C23.0292 8.64156 16.2236 8.64156 16.2236 8.64156C16.2236 8.64156 9.4889 8.64156 7.7875 9.06691C6.8659 9.35048 6.15699 10.0594 5.87342 10.981C5.44807 12.6824 5.44807 16.227 5.44807 16.227C5.44807 16.227 5.44807 19.7716 5.87342 21.473C6.15699 22.3946 6.8659 23.1744 7.7875 23.3871C9.4889 23.8833 16.2236 23.8833 16.2236 23.8833C16.2236 23.8833 22.9583 23.8833 24.6597 23.458C25.5813 23.1744 26.2903 22.4655 26.5738 21.5439C26.9992 19.8425 26.9992 16.2979 26.9992 16.2979C26.9992 16.2979 27.0701 12.6824 26.5738 11.0519Z",
        fill: "black",
      },
      {
        d: "M14.0258 19.488V13.0369L19.6972 16.227L14.0258 19.488Z",
        fill: "white",
      },
    ],
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
  },
  icnCourse: {
    paths: [
      {
        d: "M11.9998 1H12.6498V0.35H11.9998V1ZM11.9999 12.3005H12.6499V11.0005H11.9999V12.3005ZM11.9999 15.5831H12.6499V14.2831H11.9999V15.5831ZM3 1.65H11.9998V0.35H3V1.65ZM1.65 13.0998V3H0.35V13.0998H1.65ZM11.3498 1V11.6332H12.6498V1H11.3498ZM3 0.35C1.53645 0.35 0.35 1.53644 0.35 3H1.65C1.65 2.25441 2.25441 1.65 3 1.65V0.35ZM3.74979 4.21671H9.2497V2.91671H3.74979V4.21671ZM9.2497 4.75001H3.74979V6.05001H9.2497V4.75001ZM3.74979 4.75001C3.60252 4.75001 3.48314 4.63063 3.48314 4.48336H2.18314C2.18314 5.3486 2.88455 6.05001 3.74979 6.05001V4.75001ZM9.51635 4.48336C9.51635 4.63063 9.39697 4.75001 9.2497 4.75001V6.05001C10.1149 6.05001 10.8164 5.3486 10.8164 4.48336H9.51635ZM9.2497 4.21671C9.39697 4.21671 9.51635 4.33609 9.51635 4.48336H10.8164C10.8164 3.61812 10.1149 2.91671 9.2497 2.91671V4.21671ZM3.74979 2.91671C2.88455 2.91671 2.18314 3.61812 2.18314 4.48336H3.48314C3.48314 4.33609 3.60252 4.21671 3.74979 4.21671V2.91671ZM2.69903 12.3005H11.9999V11.0005H2.69903V12.3005ZM11.9999 14.2831H2.69903V15.5831H11.9999V14.2831ZM2.69903 14.2831C2.15154 14.2831 1.7077 13.8393 1.7077 13.2918H0.407703C0.407703 14.5573 1.43357 15.5831 2.69903 15.5831V14.2831ZM2.69903 11.0005C1.43356 11.0005 0.407703 12.0263 0.407703 13.2918H1.7077C1.7077 12.7443 2.15154 12.3005 2.69903 12.3005V11.0005ZM12 13H2.83348V14.3H12V13Z",
        fill: "blue",
      },
    ],
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
  },
  icnCourseLandingTab: {
    paths: [
      {
        d: "M22.6334 1.69336H23.6334V0.693359H22.6334V1.69336ZM22.6334 22.6056L22.6334 23.6056L23.6334 23.6056V22.6056H22.6334ZM4.245 22.6056L4.24501 21.6056H4.245V22.6056ZM22.6334 30.0956H23.6334V28.0956H22.6334V30.0956ZM6 2.69336H22.6334V0.693359H6V2.69336ZM2 25.49V6.69336H0V25.49H2ZM21.6334 1.69336V22.6056H23.6334V1.69336H21.6334ZM6 0.693359C2.68629 0.693359 0 3.37965 0 6.69336H2C2 4.48422 3.79086 2.69336 6 2.69336V0.693359ZM6.40834 7.74098H17.225V5.74098H6.40834V7.74098ZM17.225 9.34654H6.40834V11.3465H17.225V9.34654ZM6.40834 9.34654C5.96498 9.34654 5.60556 8.98712 5.60556 8.54376H3.60556C3.60556 10.0917 4.86041 11.3465 6.40834 11.3465V9.34654ZM18.0278 8.54376C18.0278 8.98712 17.6684 9.34654 17.225 9.34654V11.3465C18.7729 11.3465 20.0278 10.0917 20.0278 8.54376H18.0278ZM17.225 7.74098C17.6684 7.74098 18.0278 8.1004 18.0278 8.54376H20.0278C20.0278 6.99583 18.7729 5.74098 17.225 5.74098V7.74098ZM6.40834 5.74098C4.86041 5.74098 3.60556 6.99583 3.60556 8.54376H5.60556C5.60556 8.1004 5.96498 7.74098 6.40834 7.74098V5.74098ZM4.245 23.6056L22.6334 23.6056L22.6334 21.6056L4.24501 21.6056L4.245 23.6056ZM22.6334 28.0956H4.245V30.0956H22.6334V28.0956ZM4.245 28.0956C3.00512 28.0956 2 27.0904 2 25.8506H0C0 28.195 1.90055 30.0956 4.245 30.0956V28.0956ZM4.245 21.6056C1.90055 21.6056 0 23.5061 0 25.8506H2C2 24.6107 3.00512 23.6056 4.245 23.6056V21.6056ZM22.6334 25.4898L4.60557 25.4898L4.60557 27.4898L22.6334 27.4898L22.6334 25.4898Z",
        fill: "black",
      },
    ],
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
  },
  icnMyPath: {
    paths: [
      {
        d: "M0.8,10.3V0.7L9,5.5L0.8,10.3z M2.8,4.2v2.6L5,5.5L2.8,4.2z",
        fill: "black",
      },
      {
        d: "M20.3,34.3v-9.5l8.3,4.8L20.3,34.3z M22.3,28.2v2.6l2.3-1.3L22.3,28.2z",
        fill: "black",
      },
      {
        d: "M18.3,21.8L10,17l8.3-4.8V21.8z M14,17l2.3,1.3v-2.6L14,17z",
        fill: "black",
      },
      {
        d: "M21.3,19h-3.8v-2h3.8c2.9,0,5.3-2.4,5.3-5.3s-2.4-5.3-5.3-5.3H6.8v-2h14.5c4,0,7.3,3.3,7.3,7.3 S25.2,19,21.3,19z",
        fill: "black",
      },
      {
        d: "M21.2,30.5h-13c-4,0-7.3-3.3-7.3-7.3S4.3,16,8.2,16H12v2H8.2C5.4,18,3,20.4,3,23.3s2.4,5.3,5.3,5.3h13V30.5z",
        fill: "black",
      },
      {
        d: "M17.5,5.5l-5.3,3V2.5L17.5,5.5z",
        fill: "danger_select",
      },
      {
        d: "M11.2,10.3V0.7l8.3,4.8L11.2,10.3z M13.2,4.2v2.6l2.3-1.3L13.2,4.2z",
        fill: "black",
      },
      {
        d: "M17.5,29.5l-5.3,3v-6.1L17.5,29.5z",
        fill: "danger_select",
      },
      {
        d: "M11.2,34.3v-9.5l8.3,4.8L11.2,34.3z M13.2,28.2v2.6l2.3-1.3L13.2,28.2z",
        fill: "black",
      },
    ],
    width: 29,
    height: 35,
    viewBox: "0 0 29 35",
    style: "enable-background:new 0 0 29 35;",
  },
  icnHelp: {
    paths: [
      {
        d: "M8.8,21.4c-0.7,0-1.4-0.4-1.7-1l-1.4-2.5H2.9c-1.6,0-2.9-1.3-2.9-2.9V2.9C0,1.3,1.3,0,2.9,0H21 c1.6,0,2.9,1.3,2.9,2.9v12.2c0,1.6-1.3,2.9-2.9,2.9h-9.1l-1.4,2.5C10.2,21,9.5,21.4,8.8,21.4z M2.9,2C2.4,2,2,2.4,2,2.9v12.2 c0,0.5,0.4,0.9,0.9,0.9h2.8c0.7,0,1.4,0.4,1.7,1l1.4,2.5l1.4-2.5c0.4-0.6,1-1,1.7-1H21c0.5,0,0.9-0.4,0.9-0.9V2.9 C21.9,2.4,21.5,2,21,2H2.9z",
        fill: "black",
      },
      {
        d: "M27.4,29.8C27.4,29.8,27.4,29.8,27.4,29.8c-0.7,0-1.2-0.3-1.6-0.9l-1.6-2.7h-9.1c-1.6,0-2.9-1.3-2.9-2.9v-4.6 h2v4.6c0,0.5,0.4,0.9,0.9,0.9h9.2c0.6,0,1.2,0.3,1.6,0.9l1.5,2.5l1.5-2.5c0.3-0.6,0.9-0.9,1.6-0.9h2.9c0.5,0,0.9-0.4,0.9-0.9V11.1 c0-0.5-0.4-0.9-0.9-0.9h-7.8v-2h7.8c1.6,0,2.9,1.3,2.9,2.9v12.2c0,1.6-1.3,2.9-2.9,2.9h-2.8l-1.6,2.7C28.6,29.5,28,29.8,27.4,29.8z",
        fill: "black",
      },
    ],
    width: 37,
    height: 30,
    viewBox: "0 0 37 30",
    style: "enable-background:new 0 0 29 35;",
  },
  icnLearningPath: {
    paths: [
      {
        d: "M12.6,9.7h-1.8V6.1h2c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8h-0.2c-1.5,0-2.8,1.3-2.8,2.8v1.8H6.3l0-1.8 c0-1.5-1.3-2.8-2.8-2.8H3.3c-1.5,0-2.8,1.3-2.8,2.8s1.3,2.8,2.8,2.8h2v3.6H3.5c-1.5,0-2.8,1.3-2.8,2.8v0.2c0,1.5,1.3,2.8,2.8,2.8 c1.5,0,2.8-1.3,2.8-2.8v-2h3.5v2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8v-0.2C15.4,10.9,14.1,9.7,12.6,9.7z M10.8,3.3 c0-1,0.8-1.8,1.8-1.8h0.2c1,0,1.8,0.8,1.8,1.8c0,1-0.8,1.8-1.8,1.8h-2V3.3z M5.3,12.7c0,1-0.8,1.8-1.8,1.8c-1,0-1.8-0.8-1.8-1.8 v-0.2c0-1,0.8-1.8,1.8-1.8h1.8V12.7z M3.3,5.1c-1,0-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8h0.2c1,0,1.8,0.8,1.8,1.8l0,1.8H3.3z M6.3,9.7 V6.1h3.5v3.6H6.3z M14.4,12.7c0,1-0.8,1.8-1.8,1.8s-1.8-0.8-1.8-1.8v-2h1.8c1,0,1.8,0.8,1.8,1.8V12.7z",
        fill: "blue",
      },
    ],
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    style: "enable-background:new 0 0 16 16;",
  },
  icnHistory: {
    rectangles: [
      {
        width: "8.3",
        height: "1.4",
        x: "6.9",
        fill: "blue",
      },
      {
        width: "15.2",
        height: "1.4",
        y: "8.3",
        fill: "blue",
      },
      {
        width: "8.3",
        height: "1.4",
        x: "6.9",
        y: "4.2",
        fill: "blue",
      },
      {
        width: "15.2",
        height: "1.4",
        y: "12.5",
        fill: "blue",
      },
      {
        width: "15.2",
        height: "1.4",
        y: "16.6",
        fill: "blue",
      },
    ],
    paths: [
      {
        d: "M2.8,5.5C2.8,4,4,2.8,5.5,2.8C4,2.7,2.8,1.5,2.8,0c0,1.5-1.2,2.7-2.8,2.8C1.5,2.8,2.8,4,2.8,5.5z",
        fill: "blue",
      },
    ],
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    style: "enable-background:new 0 0 16 18;",
  },
  icnMyCourses: {
    paths: [
      {
        d: "M24 23C24 16.875 19.375 11.75 13.375 11.125C15.875 10.5 17.75 8.25 17.75 5.625C17.75 2.5 15.25 0 12.125 0C8.875 0 6.375 2.5 6.375 5.625C6.375 8.25 8.25 10.5 10.75 11.125C4.625 11.75 0 16.875 0 23H8.75V22.75C8.75 21.25 7.375 20 5.75 20H5V15L12 17.375L19 15V23H24Z",
        fill: "gray3",
      },
    ],
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
  },
  icnCatalogue: {
    paths: [
      {
        d: "M10.5712 12.964H1V1H10.5712V12.964ZM10.5712 22.5352H1V15.3569H10.5712V22.5352ZM12.9639 22.5352H22.5351V10.5712H12.9639V22.5352ZM12.9639 8.17839V1H22.5351V8.17839H12.9639Z",
        stroke: "gray3",
      },
    ],
    strokeWidth: 1.2,
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
  },
  icnCodeChallenge: {
    paths: [
      {
        d: "M8.73908 7.28618L0 12.4017V9.84396L5.43528 6.54016L0 3.23636V0.785156L8.63251 6.00729V7.28618H8.73908Z",
        fill: "blue",
      },
      {
        d: "M10.5514 13.9999V11.975H18.2247V13.9999H10.5514Z",
        fill: "blue",
      },
    ],
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
  },
  icnEditorText: {
    paths: [
      {
        d: "M0.5 0.5H6.5M0.5 9.5H6.5M0.5 12.5H6.5M0.5 6.5H6.5M0.5 3.5H15.5M9.5 0.5H11.5M9.5 9.5H11.5",
        stroke: "darkBlack",
      },
    ],
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    strokeLineCap: "round",
    strokeLineJoin: "round",
  },
  icnFacebook: {
    paths: [
      {
        d: "M3.64062 28.7H9.44063V14.2H13.4406L13.8406 9.4H9.44063C9.44063 9.4 9.44063 7.6 9.44063 6.6C9.44063 5.5 9.64062 5 10.7406 5C11.6406 5 13.8406 5 13.8406 5V0C13.8406 0 10.5406 0 9.84062 0C5.54062 0 3.64062 1.9 3.64062 5.5C3.64062 8.7 3.64062 9.4 3.64062 9.4H0.640625V14.3H3.64062V28.7Z",
        fill: "black",
      },
    ],
    width: 14,
    height: 29,
    viewBox: "0 0 14 29",
  },
  icnGoogle: {
    paths: [
      {
        d: "M20.7 10.7H11.1V13.4H17.6C16.8 16.7 14.5 18.8 11.3 18.8C7.1 18.8 3.8 15.4 3.8 11.3C3.8 7.2 7.2 3.8 11.3 3.8C13.3 3.8 15.1 4.6 16.4 5.8L18.5 4C16.6 2.2 14.1 1 11.3 1C5.6 1 1 5.6 1 11.3C1 17 5.6 21.6 11.3 21.6C16.8 21.6 20.7 17.4 20.7 11.7V10.7Z",
        fill: "black",
      },
      {
        d: "M34.5 10.8H30.5V6.8H28V10.8H24V13.3H28V17.3H30.5V13.3H34.5V10.8Z",
        fill: "black",
      },
    ],
    width: 35,
    height: 23,
    viewBox: "0 0 35 23",
  },
  icnTwitter: {
    paths: [
      {
        d: "M0.640625 21.6892C3.31464 23.4719 6.58288 24.5118 10.1482 24.5118C21.5871 24.5118 28.1236 14.8556 27.6779 6.09081C28.8664 5.19947 29.9062 4.15958 30.7976 2.82257C29.7577 3.26824 28.5692 3.71391 27.2322 3.86247C28.5692 3.11968 29.4606 1.93123 29.9062 0.44567C28.7178 1.18845 27.3808 1.63412 26.0438 1.93123C24.8553 0.742782 23.3698 0 21.5871 0C17.5761 0 14.6049 3.71391 15.4963 7.57638C10.2968 7.27926 5.8401 4.90236 2.72042 1.18845C1.0863 4.01102 1.82908 7.57638 4.65165 9.50761C3.61176 9.50761 2.72042 9.2105 1.82908 8.76483C1.82908 11.5874 3.76031 14.2614 6.73144 14.8556C5.8401 15.1528 4.94876 15.1528 3.90887 15.0042C4.65165 17.5297 7.02855 19.3123 9.70257 19.3123C7.17711 21.095 3.90887 22.1349 0.640625 21.6892Z",
        fill: "black",
      },
    ],
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
  },
  icnEmail: {
    paths: [
      {
        d: "M14.1992 0L28.1992 8.7H0.199219L14.1992 0Z",
        fill: "black",
      },
      {
        d: "M28.4 22.7C28.4 24.1 27.3 25.2 25.9 25.2H2.5C1.1 25.2 0 24.1 0 22.7V9.3C0 9.1 0 9 0 8.9L13.4 17.2C13.4 17.2 13.4 17.2 13.5 17.2C13.5 17.2 13.5 17.2 13.6 17.2C13.7 17.2 13.8 17.3 13.9 17.3C14 17.3 14.1 17.3 14.2 17.3C14.3 17.3 14.4 17.3 14.5 17.3C14.6 17.3 14.7 17.2 14.8 17.2C14.8 17.2 14.8 17.2 14.9 17.2C14.9 17.2 14.9 17.2 15 17.2L28.4 8.9C28.4 9 28.4 9.2 28.4 9.3V22.7Z",
        fill: "black",
      },
    ],
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
  },
  icnBlueStar: {
    paths: [
      {
        d: "M12.524 0C12.428 6.8618 6.8618 12.428 0 12.476C6.8618 12.572 12.428 18.1382 12.524 25C12.62 18.1382 18.1382 12.572 25 12.476C18.1382 12.428 12.62 6.8618 12.524 0Z",
        fill: "blue",
      },
    ],
    width: 25,
    hegith: 25,
    viewBox: "0 0 25 25",
  },
  icnGrayCross: {
    paths: [
      {
        d: "M1.13093 0.424622L16.6873 15.981M0.423828 15.981L15.9802 0.424622",
        fill: "gray3",
      },
    ],
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
  },
  icnGreenArrow: {
    paths: [
      {
        d: "M20.9297 23.0203L18.559 23.5003L15.6651 10.5151L2.62598 13.1551L2.09982 10.7941C1.9883 10.2937 2.30409 9.80735 2.80658 9.70561L18.2165 6.58566L21.6365 21.9318C21.748 22.4322 21.4322 22.9185 20.9297 23.0203Z",
        fill: "green",
      },
    ],
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
  },
  icnGreenEllipse: {
    paths: [
      {
        d: "M13.8558 7.6779C13.8558 11.0899 11.0899 13.8558 7.6779 13.8558C4.26594 13.8558 1.5 11.0899 1.5 7.6779C1.5 4.26594 4.26594 1.5 7.6779 1.5C11.0899 1.5 13.8558 4.26594 13.8558 7.6779Z",
        stroke: "green",
      },
    ],
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    strokeWidth: 3,
  },
  icnPinkCircledSquare: {
    paths: [
      {
        d: "M0.00195312 15.3556L15.3576 15.4352L15.4372 0.0796366L0.0815897 0L0.00195312 15.3556ZM13.1047 7.73046C13.0893 10.6869 10.6634 13.0879 7.70688 13.0725C4.7504 13.0572 2.34947 10.6312 2.3648 7.67476C2.38013 4.71828 4.8061 2.31734 7.76258 2.33268C10.7191 2.34801 13.12 4.77398 13.1047 7.73046Z",
        fill: "pink",
      },
    ],
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
  },
  icnRedCircle: {
    paths: [
      {
        d: "M18.5 10C18.5 14.6944 14.6944 18.5 10 18.5C5.30558 18.5 1.5 14.6944 1.5 10C1.5 5.30558 5.30558 1.5 10 1.5C14.6944 1.5 18.5 5.30558 18.5 10Z",
        stroke: "incorrect",
      },
    ],
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    strokeWidth: 3,
  },
  icnRedQuarterCircle: {
    paths: [
      {
        d: "M0 0H15V15C6.7098 15 0 8.2902 0 0Z",
        fill: "incorrect",
      },
    ],
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
  },
  icnYellowEllipse: {
    paths: [
      {
        d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z",
        fill: "yellow",
      },
    ],
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
  },
  icnCalendar: {
    paths: [
      {
        d: "M12.4444 1.5H11.6667V0H10.1111V1.5H3.88889V0H2.33333V1.5H1.55556C0.692222 1.5 0.00777777 2.175 0.00777777 3L0 13.5C0 14.325 0.692222 15 1.55556 15H12.4444C13.3 15 14 14.325 14 13.5V3C14 2.175 13.3 1.5 12.4444 1.5ZM12.4444 13.5H1.55556V6H12.4444V13.5ZM12.4444 4.5H1.55556V3H12.4444V4.5ZM7 8.25H10.8889V12H7V8.25Z",
        fill: "gray3",
      },
    ],
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
  },
  icnCategory: {
    paths: [
      {
        d: "M10,0.7H1.8c-0.6,0-1.1,0.5-1.1,1.1v5.5c0,0.6,0.5,1.1,1.1,1.1H3c0.1,0,0.2,0.1,0.3,0.2l0.5,0.8c0.2,0.3,0.5,0.5,0.8,0.5c0,0,0,0,0,0c0.3,0,0.6-0.2,0.8-0.5l0.5-0.8C5.8,8.6,5.9,8.5,6,8.5h4c0.6,0,1.1-0.5,1.1-1.1V1.8C11.2,1.2,10.7,0.7,10,0.7z M10.6,7.4c0,0.3-0.2,0.5-0.5,0.5H6c-0.3,0-0.6,0.2-0.8,0.5L4.8,9.1C4.7,9.3,4.6,9.3,4.5,9.3s-0.2,0-0.3-0.2L3.8,8.3C3.6,8.1,3.3,7.9,3,7.9H1.8c-0.3,0-0.5-0.2-0.5-0.5V1.8c0-0.3,0.2-0.5,0.5-0.5H10c0.3,0,0.5,0.2,0.5,0.5V7.4z",
        fill: "gray6",
      },
      {
        d: "M6.8,3.6L5.9,2L5.1,3.6L3.3,3.9l1.3,1.3L4.3,7l1.6-0.9L7.6,7L7.3,5.2l1.3-1.3L6.8,3.6z M6.8,5.9L5.9,5.5L5.1,5.9L5.3,5L4.6,4.3l0.9-0.1l0.4-0.8l0.4,0.8l0.9,0.1L6.6,5L6.8,5.9z",
        fill: "gray6",
      },
    ],
    viewBox: "0 0 12 11",
    width: 12,
    height: 11,
  },
  icnTestFull: {
    paths: [
      {
        d: "M18,2.5C18,1.7,17.3,1,16.5,1h-15C0.7,1,0,1.7,0,2.5c0,0.5,0.3,1,0.7,1.3C0.3,4.4,0,5.2,0,6v13c0,2.2,1.8,4,4,4 h10c2.2,0,4-1.8,4-4V6c0-0.8-0.3-1.6-0.7-2.2C17.7,3.5,18,3,18,2.5z",
        fill: "blue",
      },
      {
        d: "M5,0C4.7,0,4.5,0.2,4.5,0.5v1.2C4.5,2,4.7,2.2,5,2.2S5.5,2,5.5,1.7V0.5C5.5,0.2,5.3,0,5,0z",
        fill: "gray3",
      },
      {
        d: "M9.4,0C9.1,0,8.9,0.2,8.9,0.5v1.2c0,0.3,0.2,0.5,0.5,0.5S9.9,2,9.9,1.7V0.5C9.9,0.2,9.7,0,9.4,0z",
        fill: "gray3",
      },
      {
        d: "M13.8,0c-0.3,0-0.5,0.2-0.5,0.5v1.2c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5V0.5C14.3,0.2,14.1,0,13.8,0z",
        fill: "gray3",
      },
      {
        d: "M14.5,8h-6C8.2,8,8,7.8,8,7.5S8.2,7,8.5,7h6C14.8,7,15,7.2,15,7.5S14.8,8,14.5,8z",
        fill: "white",
      },
      {
        d: "M14.5,13h-6C8.2,13,8,12.8,8,12.5S8.2,12,8.5,12h6c0.3,0,0.5,0.2,0.5,0.5S14.8,13,14.5,13z",
        fill: "white",
      },
      {
        d: "M14.5,18h-6C8.2,18,8,17.8,8,17.5S8.2,17,8.5,17h6c0.3,0,0.5,0.2,0.5,0.5S14.8,18,14.5,18z",
        fill: "white",
      },
      {
        d: "M20.5,12.4c0.2-0.3,0.2-0.7,0-0.9c-0.3-0.2-0.7-0.2-0.9,0L19.1,12l-0.5-0.4l-6.3,6.8L12,20.5l2.2-0.5l6.3-6.8 L20,12.8L20.5,12.4z",
        fill: "gray3",
        fillRule: "evenodd",
        clipRule: "evenodd",
      },
      {
        d: "M4.6,9.3C3.7,9.3,3,8.6,3,7.7S3.7,6,4.6,6s1.6,0.7,1.6,1.6S5.6,9.3,4.6,9.3z M4.6,7C4.3,7,4,7.3,4,7.7 C4,8,4.3,8.3,4.6,8.3S5.3,8,5.3,7.7C5.3,7.3,5,7,4.6,7z",
        fill: "gray3",
      },
      {
        d: "M4.6,14.3c-0.9,0-1.6-0.7-1.6-1.7c0-0.9,0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6C6.3,13.5,5.6,14.3,4.6,14.3z M4.6,11.9c-0.4,0-0.6,0.3-0.6,0.6s0.3,0.7,0.6,0.7s0.6-0.3,0.6-0.7S5,11.9,4.6,11.9z",
        fill: "gray3",
      },
      {
        d: "M4.6,19.2c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.7,1.6-1.7s1.6,0.7,1.6,1.7C6.3,18.5,5.6,19.2,4.6,19.2z M4.6,16.9c-0.4,0-0.6,0.3-0.6,0.7s0.3,0.6,0.6,0.6s0.6-0.3,0.6-0.6S5,16.9,4.6,16.9z",
        fill: "gray3",
      },
    ],
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    style: "enable-background:new 0 0 21 23;",
  },
  icnTestEmpty: {
    paths: [
      {
        d: "M20.3,12.7c0.2-0.2,0.2-0.6,0-0.9c-0.2-0.2-0.6-0.2-0.9,0L19,12.4l-0.4-0.4l-5.8,6.3l-0.3,2.1l2-0.4l5.8-6.3 l-0.4-0.4L20.3,12.7z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "black",
      },
      {
        d: "M18,2.5C18,1.7,17.3,1,16.5,1h-2.6V0.7c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5V1H9.5V0.7 c0-0.3-0.2-0.5-0.5-0.5S8.5,0.4,8.5,0.7V1H5.1V0.7c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5V1H1.5C0.7,1,0,1.7,0,2.5 c0,0.5,0.3,1,0.7,1.3C0.3,4.4,0,5.2,0,6v13c0,2.2,1.8,4,4,4h10c2.2,0,4-1.8,4-4V6c0-0.8-0.3-1.6-0.7-2.2C17.7,3.5,18,3,18,2.5z M16.6,3c0,0-0.1,0-0.1,0H14H4H1.5c0,0-0.1,0-0.1,0C1.2,2.9,1,2.7,1,2.5C1,2.2,1.2,2,1.5,2h2.6c0,0.2,0.2,0.4,0.5,0.4 c0.3,0,0.5-0.2,0.5-0.4h3.4c0,0.2,0.2,0.4,0.5,0.4S9.5,2.2,9.5,2h3.4c0,0.2,0.2,0.4,0.5,0.4c0.3,0,0.5-0.2,0.5-0.4h2.6 C16.8,2,17,2.2,17,2.5C17,2.7,16.8,2.9,16.6,3z M17,19c0,1.7-1.3,3-3,3H4c-1.7,0-3-1.3-3-3V6c0-0.8,0.3-1.5,0.8-2h14.5 C16.7,4.5,17,5.2,17,6V19z",
        fill: "black",
      },
      {
        d: "M14.5,7h-6C8.2,7,8,7.2,8,7.5S8.2,8,8.5,8h6C14.8,8,15,7.8,15,7.5S14.8,7,14.5,7z",
        fill: "black",
      },
      {
        d: "M14.5,12h-6C8.2,12,8,12.2,8,12.5S8.2,13,8.5,13h6c0.3,0,0.5-0.2,0.5-0.5S14.8,12,14.5,12z",
        fill: "black",
      },
      {
        d: "M14.5,17h-6C8.2,17,8,17.2,8,17.5S8.2,18,8.5,18h6c0.3,0,0.5-0.2,0.5-0.5S14.8,17,14.5,17z",
        fill: "black",
      },
      {
        d: "M4.7,6C3.7,6,3,6.7,3,7.6c0,0.9,0.7,1.7,1.7,1.7c0.9,0,1.6-0.7,1.6-1.7C6.3,6.7,5.6,6,4.7,6z M4.7,8.3 C4.3,8.3,4,8,4,7.6C4,7.3,4.3,7,4.7,7C5,7,5.3,7.3,5.3,7.6C5.3,8,5,8.3,4.7,8.3z",
        fill: "black",
      },
      {
        d: "M4.6,10.9c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.7,1.6,1.7s1.6-0.7,1.6-1.7C6.3,11.7,5.6,10.9,4.6,10.9z M4.6,13.3C4.3,13.3,4,13,4,12.6s0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6S5,13.3,4.6,13.3z",
        fill: "black",
      },
      {
        d: "M4.6,15.9c-0.9,0-1.6,0.7-1.6,1.7c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C6.3,16.6,5.6,15.9,4.6,15.9z M4.6,18.2c-0.4,0-0.6-0.3-0.6-0.6s0.3-0.7,0.6-0.7s0.6,0.3,0.6,0.7S5,18.2,4.6,18.2z",
        fill: "black",
      },
    ],
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    style: "enable-background:new 0 0 21 23;",
  },
  icnLessonFull: {
    paths: [
      {
        d: "M1.9,4c0-2.2,1.8-4,4-4h10.3c1.1,0,2,0.9,2,2v16.8c0,1.1-0.9,2-2,2H5.9c-2.2,0-4-1.8-4-4V4z",
        fill: "blue",
      },
      {
        d: "M11.8,22h4.7v-8.6l-2.3,1.8l-2.3-1.8V22z",
        fill: "gray3",
      },
      {
        d: "M15.5,6.5h-3.4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h3.4C15.7,5.5,16,5.7,16,6S15.7,6.5,15.5,6.5z",
        fill: "gray0",
      },
      {
        d: "M15.5,8.8h-3.4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h3.4C15.7,7.8,16,8,16,8.3S15.7,8.8,15.5,8.8z",
        fill: "gray0",
      },
      {
        d: "M0.7,6.1c0-0.3,0.3-0.6,0.6-0.6h1.7c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6H1.3C1,6.7,0.7,6.4,0.7,6.1z",
        fill: "gray3",
        fillRule: "evenodd",
        clipRule: "evenodd",
      },
      {
        d: "M0.7,15.3c0-0.3,0.3-0.6,0.6-0.6h1.7c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6H1.3 C1,15.9,0.7,15.6,0.7,15.3z",
        fill: "gray3",
        fillRule: "evenodd",
        clipRule: "evenodd",
      },
    ],
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    style: "enable-background:new 0 0 19 22;",
  },
  icnLessonEmpty: {
    paths: [
      {
        d: "M15.5,7.8h-3.4c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5h3.4c0.3,0,0.5-0.2,0.5-0.5 C16,8,15.7,7.8,15.5,7.8z",
        fill: "black",
      },
      {
        d: "M16.2,0H5.9c-2.2,0-4,1.8-4,4v1.5H1.3C1,5.5,0.7,5.8,0.7,6.1c0,0.3,0.3,0.6,0.6,0.6h0.6v7.9H1.3 c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6h0.6v0.9c0,2.2,1.8,4,4,4h5.9V22h4.7v-1.2c1-0.1,1.7-1,1.7-2V2 C18.2,0.9,17.3,0,16.2,0z M17.2,18.8c0,0.5-0.3,0.9-0.7,1v-6.3l-2.3,1.8l-2.3-1.8v6.3H5.9c-1.7,0-3-1.3-3-3v-0.9h0.2 c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6H2.9V6.7h0.2c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6H2.9V4c0-1.7,1.3-3,3-3 h10.3c0.6,0,1,0.4,1,1V18.8z",
        fill: "black",
      },
      {
        d: "M15.5,5.5h-3.4c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5h3.4C15.7,6.5,16,6.3,16,6 C16,5.7,15.7,5.5,15.5,5.5z",
        fill: "black",
      },
    ],
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    style: "enable-background:new 0 0 19 22;",
  },
  icnEditorFull: {
    paths: [
      {
        d: "M0 4.91284C0 2.7037 1.79086 0.912842 4 0.912842H13.2174C15.4265 0.912842 17.2174 2.7037 17.2174 4.91284V16.9998C17.2174 19.2089 15.4265 20.9998 13.2174 20.9998H4C1.79086 20.9998 0 19.2089 0 16.9998V4.91284Z",
        fill: "blue",
      },
      {
        d: "M8.27469 12.9239L3 16.0115V14.4677L6.2806 12.4736L3 10.4795V9L8.21037 12.152V12.9239H8.27469Z",
        fill: "white",
      },
      {
        d: "M9.36865 16.9761V15.7539H14.0001V16.9761H9.36865Z",
        fill: "white",
      },
      {
        d: "M0 5.5L17.22 5.5",
        fill: "blue",
      },
      {
        d: "M6 3.5C6 3.77614 5.77614 4 5.5 4C5.22386 4 5 3.77614 5 3.5C5 3.22386 5.22386 3 5.5 3C5.77614 3 6 3.22386 6 3.5Z",
        fill: "blue",
      },
      {
        d: "M4 3.5C4 3.77614 3.77614 4 3.5 4C3.22386 4 3 3.77614 3 3.5C3 3.22386 3.22386 3 3.5 3C3.77614 3 4 3.22386 4 3.5Z",
        fill: "blue",
      },
      {
        d: "M8 3.5C8 3.77614 7.77614 4 7.5 4C7.22386 4 7 3.77614 7 3.5C7 3.22386 7.22386 3 7.5 3C7.77614 3 8 3.22386 8 3.5Z",
        fill: "blue",
      },
    ],
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    style: "enable-background:new 0 0 17.3 20.1;",
  },
  icnEditorEmpty: {
    paths: [
      {
        d: "M13.2,0H4C1.8,0,0,1.8,0,4v12.1c0,2.2,1.8,4,4,4h9.2c2.2,0,4-1.8,4-4V4C17.2,1.8,15.4,0,13.2,0z M1,4 c0-1.7,1.3-3,3-3h9.2c1.7,0,3,1.3,3,3v0.1L1,4L1,4z M13.2,19.1H4c-1.7,0-3-1.3-3-3v-11h15.2v11C16.2,17.8,14.9,19.1,13.2,19.1z",
        fill: "fill: black",
      },
    ],
    polygons: [
      {
        points: "8.2,11.3 3,8.1 3,9.6 6.3,11.6 3,13.6 3,15.1 8.3,12 8.2,12",
        fill: "black",
      },
    ],
    rectangles: [
      {
        width: "4.6",
        height: "1.2",
        x: "9.4",
        y: "14.9",
        fill: "black",
      },
    ],
    circles: [
      {
        fill: "black",
        cx: "5.5",
        cy: "2.6",
        r: "0.5",
      },
      {
        fill: "black",
        cx: "3.5",
        cy: "2.6",
        r: "0.5",
      },
      {
        fill: "black",
        cx: "7.5",
        cy: "2.6",
        r: "0.5",
      },
    ],
    width: 17.3,
    height: 20.1,
    viewBox: "0 0 17.3 20.1",
    style: "enable-background:new 0 0 17.3 20.1;",
  },
  icnCalendarPink: {
    paths: [
      {
        d: "M12.4444 1.5H11.6667V0H10.1111V1.5H3.88889V0H2.33333V1.5H1.55556C0.692222 1.5 0.00777777 2.175 0.00777777 3L0 13.5C0 14.325 0.692222 15 1.55556 15H12.4444C13.3 15 14 14.325 14 13.5V3C14 2.175 13.3 1.5 12.4444 1.5ZM12.4444 13.5H1.55556V6H12.4444V13.5ZM12.4444 4.5H1.55556V3H12.4444V4.5ZM7 8.25H10.8889V12H7V8.25Z",
        fill: "pink",
      },
    ],
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
  },
  icnCommentPink: {
    paths: [
      {
        d: "M2.18644 1C1.53119 1 1 1.52912 1 2.18182V9.98182C1 10.6345 1.53119 11.1636 2.18644 11.1636H3.76285C4.11951 11.1636 4.44917 11.3536 4.62803 11.6622L5.11787 12.5073C5.50315 13.172 6.46295 13.172 6.84823 12.5073L7.33808 11.6622C7.51693 11.3536 7.84659 11.1636 8.20325 11.1636H13.8136C14.4688 11.1636 15 10.6345 15 9.98182V2.18182C15 1.52912 14.4688 1 13.8136 1H2.18644Z",
        stroke: "pink",
        strokeWidth: "1.5",
      },
      {
        d: "M7.95455 3L8.82286 4.75941L10.7645 5.04154L9.35952 6.41105L9.69118 8.34482L7.95455 7.43182L6.21791 8.34482L6.54958 6.41105L5.14461 5.04154L7.08623 4.75941L7.95455 3Z",
        fill: "pink",
      },
    ],
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
  },
  icnGraduationHatPink: {
    paths: [
      {
        d: "M9.33357 7.72181C9.25905 7.75322 9.17501 7.75322 9.1005 7.72181L0.655768 4.16191C0.411148 4.05879 0.411148 3.71215 0.655769 3.60902L9.1005 0.0491255C9.17501 0.0177137 9.25905 0.0177136 9.33357 0.0491255L17.7783 3.60903C18.0229 3.71215 18.0229 4.05879 17.7783 4.16191L9.33357 7.72181Z",
        fill: "pink",
      },
      {
        d: "M1.54639 4.07678V8.65917",
        fill: "none",
        stroke: "pink",
        strokeWidth: "1.5",
        strokeMiterlimit: "10",
      },
      {
        d: "M4.62853 9.90116C7.00564 9.90116 8.93554 11.7326 8.95971 14H9.04029C9.06446 11.7326 10.9944 9.90116 13.3715 9.90116C13.585 9.90116 13.7945 9.91861 14 9.94186V5H4V9.94186C4.20548 9.91279 4.41499 9.90116 4.62853 9.90116Z",
        stroke: "pink",
        strokeWidth: "1.5",
        strokeMiterlimit: "10",
      },
    ],
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
  },
  icnCourses: {
    paths: [
      {
        d: "M1 7.97518V2.21484C1 1.66256 1.44772 1.21484 2 1.21484H7.16702V7.15575",
        stroke: "#5D6174",
        strokeWidth: "0.75",
      },
      {
        d: "M7.16702 7.15625H1.92186C1.41273 7.15625 1 7.56898 1 8.07811V8.07811C1 8.58725 1.41273 8.99998 1.92186 8.99998H7.16702",
        stroke: "#5D6174",
        strokeWidth: "0.75",
        strokeLinecap: "square",
      },
    ],
    rectangles: [
      {
        width: "4.11135",
        height: "2.64844",
        x: "2.02783",
        y: "2.64844",
        rx: "0.512147",
        stroke: "#5D6174",
        strokeWidth: "0.75",
      },
    ],
    width: "8",
    height: "10",
    viewBox: "0 0 8 10",
    fill: "none",
  },
};

const Icon = React.forwardRef(
  (
    {
      icon,
      width,
      height,
      fill,
      hoverFill,
      onClick,
      className,
      pathStrokeWidth,
      pathStrokeLineCap,
      pathStrokeLineJoin,
      pathClipRule,
      pathFillRule,
      pathFill,
      pathStroke,
      pathStrokeMiterlimit,
      stroke,
      viewBox,
    },
    ref
  ) => {
    const themeContext = useContext(ThemeContext);

    if (icon) {
      return (
        <IconContainer
          className={`icon ${className}`}
          ref={ref}
          onClick={onClick}
          width={width ? width : icons[icon]?.width}
          height={height ? height : icons[icon]?.height}
          viewBox={viewBox ? viewBox : icons?.[icon]?.viewBox}
          stroke={stroke ? stroke : icons[icon]?.stroke}
          hoverFill={hoverFill ? hoverFill : icons[icon]?.hoverFill}
          fill={fill ? fill : icons[icon]?.fill}
          style={icons[icon]?.style ? icons[icon?.style] : {}}
        >
          {icons[icon]?.circles &&
            icons[icon]?.circles.map((circle, index) => {
              return (
                <Circle
                  themeContext={themeContext}
                  className={`
                ${pathStroke
                      ? ""
                      : circle.stroke &&
                      "stroke-" + circle.stroke.replace("#", "")
                    } 
                ${pathStroke
                      ? ""
                      : circle.fill && "fill-" + circle.fill.replace("#", "")
                    } 
                `}
                  key={`circle-${index}`}
                  cx={
                    circle.cx
                      ? circle.cx
                      : icons[icon].circle && icons[icon].circle.cx
                  }
                  cy={
                    circle.cy
                      ? circle.cy
                      : icons[icon].circle && icons[icon].circle.cy
                  }
                  r={
                    circle.r
                      ? circle.r
                      : icons[icon].circle && icons[icon].circle.r
                  }
                  strokeWidth={
                    circle.strokeWidth
                      ? circle.strokeWidth
                      : icons[icon].circle && icons[icon].circle.strokeWidth
                  }
                  stroke={pathStroke ? pathStroke : ""}
                  fill={pathFill ? pathFill : ""}
                  stroking={circle.stroke && circle.stroke.replace("#", "")}
                  filling={circle.fill && circle.fill.replace("#", "")}
                />
              );
            })}
          {icons[icon]?.paths &&
            icons[icon]?.paths.map((path, index) => {
              return (
                <Path
                  themeContext={themeContext}
                  className={`
                ${pathStroke
                      ? ""
                      : path.stroke && "stroke-" + path.stroke.replace("#", "")
                    } 
                ${pathStroke
                      ? ""
                      : path.fill && "fill-" + path.fill.replace("#", "")
                    } 
              
                `}
                  stroke={pathStroke ? pathStroke : ""}
                  fill={pathFill ? pathFill : ""}
                  filling={path.fill && path.fill.replace("#", "")}
                  stroking={path.stroke && path.stroke.replace("#", "")}
                  key={`path-${index}`}
                  d={path.d}
                  strokeWidth={
                    pathStrokeWidth ? pathStrokeWidth : path.strokeWidth
                  }
                  strokeLineCap={
                    pathStrokeLineCap ? pathStrokeLineCap : path.strokeLineCap
                  }
                  strokeLineJoin={
                    pathStrokeLineJoin
                      ? pathStrokeLineJoin
                      : path.strokeLineJoin
                  }
                  strokeMiterlimit={
                    pathStrokeMiterlimit
                      ? pathStrokeMiterlimit
                      : path.strokeMiterlimit
                  }
                  clipRule={pathClipRule ? pathClipRule : path.clipRule}
                  fillRule={pathFillRule ? pathFillRule : path.fillRule}
                />
              );
            })}
          {icons[icon]?.rectangles &&
            icons[icon]?.rectangles.map((rectangle, index) => (
              <Rect
                themeContext={themeContext}
                className={`
            ${pathStroke
                    ? ""
                    : rectangle.stroke &&
                    "stroke-" + rectangle.stroke.replace("#", "")
                  } 
            ${pathFill
                    ? ""
                    : rectangle.fill && "fill-" + rectangle.fill.replace("#", "")
                  } 
            `}
                key={`rect-${index}`}
                x={rectangle.x && rectangle.x}
                y={rectangle.y && rectangle.y}
                width={rectangle.width && rectangle.width}
                height={rectangle.height && rectangle.height}
                stroke={pathStroke ? pathStroke : ""}
                fill={pathFill ? pathFill : ""}
                stroking={rectangle.stroke && rectangle.stroke.replace("#", "")}
                filling={rectangle.fill && rectangle.fill.replace("#", "")}
              />
            ))}
          {icons[icon]?.polygons &&
            icons[icon]?.polygons.map((polygon, index) => (
              <Polygon
                themeContext={themeContext}
                className={`
            ${pathStroke
                    ? ""
                    : polygon.stroke && "stroke-" + polygon.stroke.replace("#", "")
                  } 
            ${pathStroke
                    ? ""
                    : polygon.fill && "fill-" + polygon.fill.replace("#", "")
                  } 
            `}
                key={`polygon-${index}`}
                points={polygon.points}
                stroke={pathStroke ? pathStroke : ""}
                fill={pathFill ? pathFill : ""}
                stroking={polygon.stroke && polygon.stroke.replace("#", "")}
                filling={polygon.fill && polygon.fill.replace("#", "")}
              />
            ))}
        </IconContainer>
      );
    }
  }
);

export default withTheme(Icon);
